import React from 'react';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import $ from 'jquery';
import RequiredFormControl from '../../../form/RequiredFormControl.jsx';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import {
  Glyphicon,
  Row,
  Modal,
  Col,
  OverlayTrigger,
  Popover,
} from 'react-bootstrap';
import { List, Map, Set, fromJS } from 'immutable';
import {
  FormControl,
  Button,
  ButtonWithFuncBound,
  DateTimePicker2 as DateTimePicker,
} from '../../../form/FormControls.jsx';
import FancyInput from '@/component/form/numinput/index.jsx';
import {
  dateTimePickerFormat,
  createFormData,
  UrlWrappedLink,
  locationFallThroughInitial,
} from '../../../../util/util.jsx';
import RefPicker from '../../../dict/simple/select/DictPicker.jsx';
import CounterpartyPicker from '../../../dict/simple/select/MultiDictsPicker.jsx';
import {
  tryToSaveDealPayment,
  updateDealPayment,
  addDealPayment,
  removeDealPayment,
  addDealExpense,
  updateDealExpense,
  removeDealExpense,
  updateTransportExpense,
  addTransportExpense,
  removeTransportExpense }
  from '../store/deal.store';
import FileDocument from './FileDocument.jsx';
import { validateRoleConfig, isUserPayment,
  hasUserAnyRole } from '../../../auth/RoleConfigFilter.jsx';
import { filterExpense } from '@/component/blogic/deals/expenses/ExpensesElement';
import { loadAllDeals, areAllTheDealsLoaded } from '../DealLoader.js';
import Label from '@/component/form/Label.jsx';
import CurrencyInput from '@/component/form/currencyinput/index.jsx';
import { getNumeric, getCurrencyValue } from '../../deals/expenses/ExpensesUtils.jsx';
import { formatCurrency, formatNumber,
  formatNumberZeroIfNull, formatQuantity } from '../elements/BaseElement.jsx';
import {
  FREIGHT_EXPENSES_TYPE,
  PRODUCT_EXPENSES_TYPE,
  BANKING_EXPENSES_TYPE,
  INTEREST_EXPENSES_TYPE } from '@/component/blogic/deals/expenses/ExpensesUtils.jsx';
import { handleFormChanged, setExpensesRebuilded } from '@/store/allaround.store.js';

import { REF_PATH as INSURANCECOMPANY_REF_PATH }
  from '@/component/dict/simple/insurancecompany/Const';
import { REF_PATH as INSPECTIONCOMPANY_REF_PATH }
  from '@/component/dict/simple/inspectioncompany/Const';
import { REF_PATH as OWNER_REF_PATH }
  from '@/component/dict/simple/owner/Const';
import { REF_PATH as VESSEL_BROKER_REF_PATH }
  from '@/component/dict/simple/vesselbroker/Const';
import { REF_PATH as FORWARDER_REF_PATH }
  from '@/component/dict/simple/forwarder/Const';
import { REF_PATH as BUYER_REF_PATH }
  from '@/component/dict/simple/buyer/Const';
import { REF_PATH as SELLER_REF_PATH }
  from '@/component/dict/simple/supplier/Const';
import { REF_PATH as EXPENSES_TYPE_REF_PATH }
  from '@/component/dict/complex/expensestype/Const';
import { REF_PATH as PRODUCER_TYPE_REF_PATH }
  from '@/component/dict/simple/producer/Const';
import { REF_PATH as TOPMANAGER_REF_PATH }
  from '@/component/dict/simple/topmanager/Const';
import { REF_PATH as DOCTYPE_REF_PATH }
  from '@/component/dict/simple/documenttype/Const';
import { REF_PATH as BANK_REF_PATH }
  from '@/component/dict/simple/bank/Const';
import {
  REF_PATH as COMMONCOUNTERPARTIES_REF_PATH,
}
  from '@/component/dict/simple/commoncounterparties/Const';
import { REF_PATH as TRADE_COUNTERPARTIES_REF_PATH,
  NAME as TRADE_COUNTERPARTIES_NAME }
  from '@/component/dict/simple/tradecounterparties/Const';
import { REF_PATH as PAYMENTMETHOD_REF_PATH } from '@/component/dict/simple/paymentmethod/Const';
import { Currency } from '@/consts/currency';
import { sortPay, sortDRCR, sortDocumentNumber, sortSimpleTextFunc,
  sortDueAmount, sortDueDate, sortPaymentAmount, sortBankRepaymentDate,
  sortPaymentDate, sortOutstanding, sortBankingCost, sortId } from './PaymentsSort';
import ProductDisplayWrapper from '@/component/dict/complex/product/ProductDisplayWrapper';
import BuyerDisplayWrapper from '@/component/dict/simple/buyer/NameDisplayWrapper';
import { loadAddDicts, areAllTheDictsLoaded } from '@/component/dict/DictLoader.js';
import { formatTransportName } from '../transport/SmallTransportDisplay';
import CreatePaymentModal from '../elements/CreatePaymentModal';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import TopManagerSelect from './TopManagerSelect.jsx';
import store from '@/store/store';
import _ from 'lodash';
import { createSelector } from 'reselect';
import DetachedPayment from './DetachedPayment';
import trash from '../../../../../style/trash.png';
import unapproved from '../../../../../style/unapproved.png';
import approved from '../../../../../style/approved.png';
import payed from '../../../../../style/payed.png';
import plus from '../../../../../style/plus.png';
import minus from '../../../../../style/minus.png';
import attach from '../../../../../style/attach.png';
import pencil from '../../../../../style/pencil.png';
import arrowleft from '../../../../../style/arrowleft.png';
import arrowright from '../../../../../style/arrowright.png';

moment.locale('en');
momentLocalizer();

/* eslint-disable */
export const ApprovedIcon = () => <img src={approved} alt={'Approved'} className={'payments-table-icon'} />;
export const UnapprovedIcon = () => <img src={unapproved} alt={'Unapproved'} className={'payments-table-icon'} />;
export const PayedIcon = () => <img src={payed} alt={'Payment complete'} className={'payments-table-icon'} />;
export const PlusIcon = () => <img src={plus} alt={'Incoming payment'} className={'payments-table-icon'} />;
export const MinusIcon = () => <img src={minus} alt={'Outgoing payment'} className={'payments-table-icon'} />;
export const EditIcon = () => <img src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'} />;
export const ResizeExpand = () => <span>
  <img src={arrowleft} alt={'edit'} title={'edit'} className={'payments-table-resize-icon'} />
  <img src={arrowright} alt={'edit'} title={'edit'} className={'payments-table-resize-icon'} />
</span>
export const ResizeCollapse = () => <span>
  <img src={arrowright} alt={'edit'} title={'edit'} className={'payments-table-resize-icon'} />
  <img src={arrowleft} alt={'edit'} title={'edit'} className={'payments-table-resize-icon'} />
</span>
/* eslint-enable */

export const BULK_PAYMENT_TYPE = { sameType: 'SAME_DEAL_TYPE', loadDis: 'LOAD_DIS_TYPE' };
export const BRIEF_MODE = 'brief';
export const DETAILED_MODE = 'detailed';

let InternalSubPaymentsContainer = undefined;

export function hasApprovedPayments(paymentsList = new List()) {
  const payments = paymentsList.get ? paymentsList : fromJS(paymentsList);
  const approvedPayments = payments.find(p => p.get('approve')
  || hasApprovedPayments(p.get('payments')));
  return (approvedPayments && approvedPayments.size > 0);
}
export function hasApprovedContractPayments(paymentsList = new List(), contractExpeseId) {
  const payments = paymentsList.get ? paymentsList : fromJS(paymentsList);
  return payments.find(p => (p.get('approve') && p.get('expensesType') == contractExpeseId));
}

export function paymentHasFinData(payment) {
  if (!payment) {
    return false;
  }
  let paymentFromJS = payment;
  if (!payment.get) {
    paymentFromJS = fromJS(payment);
  }
  return paymentFromJS && (parseFloat(paymentFromJS.get('paymentAmount'))
        || parseFloat(paymentFromJS.get('bankingCost')) || paymentFromJS.get('paymentDate'));
}

export function paymentHasSubpaymentsWithFinData(payment) {
  if (!payment) {
    return false;
  }
  if (paymentHasFinData(payment)) {
    return true;
  }
  const subpayments = payment.get('payments');
  if (!subpayments) {
    return false;
  }
  return subpayments.filter(p => paymentHasSubpaymentsWithFinData(p)).size > 0;
}

const hasSubpaymentsObj = (paymentArg) => {
  if (!paymentArg) {
    return false;
  }
  const payment = paymentArg.get ? paymentArg : fromJS(paymentArg);
  return payment.get('payments') && payment.get('payments').find(p => !p.get('isSubPartial'));
};

export const calcOutstanding = (paymentArg) => {
  const payment = paymentArg.get ? paymentArg : fromJS(paymentArg);
  let result = payment.get('dueAmount', 0.0);
  result -= getNumeric(payment.get('paymentAmount'));
  (payment.get('payments') || new List).forEach(p => {
    result -= getNumeric(p.get('paymentAmount'));
    (p.get('payments') || new List).forEach(p2 => {
      result -= getNumeric(p2.get('paymentAmount'));
    });
  });
  return result < 0 ? 0 : result;
};

export const calcContractDate = (paymentArg, props, contractDateArg) => {
  const payment = paymentArg.get ? paymentArg : fromJS(paymentArg);
  if (paymentHasSubpaymentsWithFinData(payment)) {
    return payment.get('dueDate');
  }
  if (payment.get('dueDateAnchorType') == 'CONTRACT') {
    const contractDate = contractDateArg || (props ? props.contractDate : undefined);
    if (!contractDate) {
      return undefined;
    }
    const dueDate = moment(contractDate);
    switch (payment.get('dueDateOffsetType')) {
      case 'BY':
        return dueDate.format(dateTimePickerFormat);
      case 'BEFORE':
        return dueDate.subtract(payment.get('dueDateOffsetValue', 0), 'day')
          .format(dateTimePickerFormat);
      case 'AFTER':
        return dueDate.add(payment.get('dueDateOffsetValue', 0), 'day')
          .format(dateTimePickerFormat);
      default:
        return dueDate.format(dateTimePickerFormat);
    }
  }
  return payment.get('dueDate');
};


export const calcPercentContractPayment = (paymentArg, props, productArg) => {
  const payment = paymentArg.get ? paymentArg : fromJS(paymentArg);
  if (paymentHasSubpaymentsWithFinData(payment)) {
    return payment.get('estimatedDueAmount');
  }
  const product = productArg || (props ? props.product : undefined);
  if (product && payment.get('fullCostType') == 'PERCENT') {
    if (product.get('fixedPrice') !== false
    && product.get('quantityMax') && product.get('priceValue')) {
      return (Number(product.get('quantityMax'), 0) + Number(product.get('quantityMin', 0))) / 2
      * Number(product.get('priceValue'))
      * Number(payment.get('fullCostPercent')) / 100;
    } return 0;
  }
  return payment.get('estimatedDueAmount');
};

export const onSortChange = (sortName) => {
  const sortChange = () =>
    new Promise((resolve, reject) => {
      setTimeout(() => {
        if ($(`#paymentContainer th[data-field=${sortName}]`).length) {
          resolve();
        } else {
          if ($('#paymentContainer').length) {
            reject(true);
          } else {
            reject(false);
          }
        }
      }, 500);
    }).then(
      () => {
        $('#paymentContainer th').css('background-color', '#ffffff');
        $(`#paymentContainer th[data-field=${sortName}]`).css('background-color', '#dddddd');
      },
      (repeat) => repeat ? sortChange() : null, // eslint-disable-line
    );
  return sortChange();
};

export const dealOutstandingValue = (payments) =>
  payments.reduce((sum, p) => sum + calcOutstanding(p), 0);


const sumAllBankingCost = (payment) => payment.get('payments', new List())
  .reduce((sum, p) => sum + p.get('bankingCost', 0.00) + sumAllBankingCost(p), 0);

export const updateProductPaymentCounterparty =
  (dealType, expensestypes, products, updateDealPaymentFunc, value) => {
    products.forEach((product, productIdx) => {
      const payments = product.get('payments', new List());
      const contractPaymentIndexes = payments.map((p, idx) => {
        const expensesType = expensestypes.find(elem => elem.get('id') == p.get('expensesType'));
        const isExpenseTypeContractPayment = expensesType &&
          expensesType.get('name', '').toLowerCase() == PRODUCT_EXPENSES_TYPE;
        return (dealType == 'purchase' || dealType == 'sale') && isExpenseTypeContractPayment ?
          idx : null;
      }).filter(e => e != null);
      if (contractPaymentIndexes.size > 0) {
        let newPayments = payments;
        contractPaymentIndexes.forEach(contractPaymentIndex => {
          newPayments = newPayments.set(contractPaymentIndex,
            newPayments.get(contractPaymentIndex, new Map()).set('counterparty', value));
        });
        updateDealPaymentFunc(productIdx, newPayments);
      }
    });
  };

const EXCLUDE_EXPENSE_TYPE_NAMES = ['currency cost', 'banking', 'interest'];

const expandHack = [];
expandHack.indexOf = () => 0;

export function formPaymentExpense(payment, currentExpense = new Map()) {
  const state = store.getState();
  const expensestypes = state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List());
  const currencyRates = state.getIn(['data', 'currencies', 'USD', 'rates'], [])
    .map(r => r.set('value', r.get('currency')));
  payment = payment.set('currencyRates', currencyRates);    //eslint-disable-line
  return {
    expensesType: payment.get('expensesType'),
    expensesTypeName: expensestypes ? expensestypes
      .find(e => e.get('id') == payment.get('expensesType', ''), this, new Map())
      .get('name') : '',
    isDebit: payment.get('isDebit'),
    summType: 'LS',
    actualCurrency: Currency.DOLLAR,
    actual: getCurrencyValue(payment, 'dueAmount', 'dueAmountCurrency', 'currencyRates')
      + getCurrencyValue(payment, 'bankingCost', 'dueAmountCurrency', 'currencyRates'),
    estimate: getCurrencyValue(currentExpense, 'estimate',
      'estimateCurrency', 'estimateCurrencyRates'),
    estimateCurrency: Currency.DOLLAR,
    estimateCurrencyRates: currentExpense.get('estimateCurrencyRates', currencyRates),
    paymentExpense: payment.get('bulkPaymentTransports', new List()).size == 0,
  };
}
export function formBankingPayment(payment) {
  const state = store.getState();
  const expensestypes = state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List());
  const bankingExpenseTypeId = expensestypes
    .find(e => e.get('name', '').toLowerCase() == BANKING_EXPENSES_TYPE.toLowerCase(),
      this, new Map())
    .get('id');
  const bankingCost = (payment.get('bankingCost') || 0) + sumAllBankingCost(payment);
  return payment
    .set('expensesType', bankingExpenseTypeId)
    .set('isDebit', true)
    .set('dueAmount', bankingCost)
    .set('bankingCost', 0)
    .set('payments', new List());
}

const extractBankingPayment = (payments = new List(), restrictedExpenseIds = new List()) => {
  let bankingPayments = new List();
  payments.forEach(p => {
    if (restrictedExpenseIds.includes(p.get('expensesType'))) {
      const newPayment = formBankingPayment(p);
      if (newPayment.get('dueAmount')) {
        bankingPayments = bankingPayments.push(formBankingPayment(p));
      }
    }
  });
  return payments.concat(bankingPayments);
};

export function formUnitedPaymentExpense(currentExpense = new Map(),
  allPayments = new List(), defaultActualToZero) {
  const state = store.getState();
  const expensestypes = state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List());
  const currencyRates = state.getIn(['data', 'currencies', 'USD', 'rates'], [])
    .map(r => r.set('value', r.get('currency')));
  const sameExpensePayments = allPayments.filter(p =>
    p.get('expensesType') == currentExpense.get('expensesType'))
    .map(p => p.set('currencyRates', currencyRates));
  let totalActual = defaultActualToZero ? 0 : currentExpense.get('actual');

  if (sameExpensePayments.size > 0) {
    totalActual = sameExpensePayments.reduce((result, p) => {
      let bankingCost = 0;
      const totalBankingElem = p.set('totalBank',
        (p.get('bankingCost') || 0) + sumAllBankingCost(p));
      bankingCost += getCurrencyValue(totalBankingElem, 'totalBank', 'dueAmountCurrency',
        'currencyRates');
      if (p.get('isDebit')) {
        return result + getCurrencyValue(p, 'dueAmount', 'dueAmountCurrency', 'currencyRates')
          + bankingCost;
      }
      return result - (getCurrencyValue(p, 'dueAmount', 'dueAmountCurrency', 'currencyRates')
        - bankingCost);
    }, 0);
  }
  let isDebit = totalActual > 0;
  if (!totalActual && sameExpensePayments.size == 1) {
    isDebit = sameExpensePayments.get(0).get('isDebit');
  } else if (!totalActual && sameExpensePayments.size == 0) {
    isDebit = currentExpense.get('isDebit');
  }
  return {
    expensesType: currentExpense.get('expensesType'),
    expensesTypeName: expensestypes ? expensestypes
      .find(e => e.get('id') == currentExpense.get('expensesType', ''),
        this, new Map()).get('name') : '',
    isDebit,
    summType: 'LS',
    actualCurrency: Currency.DOLLAR,
    actual: _.round(Math.abs(totalActual), 2),
    estimate: getCurrencyValue(currentExpense, 'estimate',
      'estimateCurrency', 'estimateCurrencyRates'),
    estimateCurrency: Currency.DOLLAR,
    estimateCurrencyRates: currentExpense.get('estimateCurrencyRates', currencyRates),
    paymentExpense: sameExpensePayments.size > 0,
    isBulkExpense: currentExpense.get('isBulkExpense'),
  };
}
function getTransportTitle(deal) {
  if (!deal) {
    return '';
  }
  switch (deal.get('transportType', '').toLowerCase()) {
    case 'bulk':
    case 'railcar':
    case 'truck':
      return deal.get('vesselName', '');
    case 'container': {
      let transportNameVoyage = deal.get('transportNameVoyage', []);
      if (!Array.isArray(transportNameVoyage)) {
        transportNameVoyage = transportNameVoyage.toJS();
      }
      return transportNameVoyage.map(tnv => tnv.vesselName).join('; ');
    }
    default:
      return '';
  }
}

const dictList = `${INSURANCECOMPANY_REF_PATH},${INSPECTIONCOMPANY_REF_PATH}
,${FORWARDER_REF_PATH},${VESSEL_BROKER_REF_PATH}, ${PRODUCER_TYPE_REF_PATH}
,${OWNER_REF_PATH},${BUYER_REF_PATH},${SELLER_REF_PATH}`;

class CustomCell extends React.PureComponent {
  shouldComponentUpdate(newProps) {
    let update = false;
    if (newProps.value || this.props.value) {
      update = newProps.value != this.props.value;
    }
    if (newProps.updateFields && newProps.object) {
      this.props.updateFields.forEach(field => {
        if (this.props.object[field] != newProps.object[field]) {
          update = true;
        }
      });
    }
    return update;
  }
  render() {
    return this.props.data || <div />;
  }
}
CustomCell.propTypes = {
  data: React.PropTypes.object,
  value: React.PropTypes.string,
  object: React.PropTypes.object,
  updateFields: React.PropTypes.array,
};
// eslint-disable-next-line
export class PaymentsContainer extends React.PureComponent {

  constructor(props) {
    super(props);
    this.prepareData = this.prepareData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openModalEdit = this.openModalEdit.bind(this);
    this.openDueDateEdit = this.openEditContractPayment.bind(this, 1);
    this.closeEditContractPayment = this.closeEditContractPayment.bind(this);
    this.openDueAmountEdit = this.openEditContractPayment.bind(this, 2);
    this.closeBulkPaymentModal = this.closeBulkPaymentModal.bind(this);
    this.closeTopManagerModal = this.closeTopManagerModal.bind(this);

    this.addSubPartialPaymentFormatter = this.addSubPartialPaymentFormatter.bind(this);
    this.editSubPartialPaymentFormatter = this.editSubPartialPaymentFormatter.bind(this);
    this.isExpandableRow = this.isExpandableRow.bind(this);
    this.expandComponent = this.expandComponent.bind(this);
    this.bankFormatter = this.bankFormatter.bind(this);
    this.invoiceFormatter = this.invoiceFormatter.bind(this);
    this.approveFormatter = this.approveFormatter.bind(this);
    this.topApproveFormatter = this.topApproveFormatter.bind(this);
    this.dueDateFormatter = this.dueDateFormatter.bind(this);
    this.onTopManagerSelect = this.onTopManagerSelect.bind(this);
    this.debitCreditFormatter = this.debitCreditFormatter.bind(this);
    this.finApproveFormatter = this.finApproveFormatter.bind(this);
    this.finTopApproveFormatter = this.finTopApproveFormatter.bind(this);
    this.finDebitCreditFormatter = this.finDebitCreditFormatter.bind(this);
    this.finTypeFormatter = this.finTypeFormatter.bind(this);
    this.finUserNameFormatter = this.finUserNameFormatter.bind(this);
    this.dueAmountFormatter = this.dueAmountFormatter.bind(this);
    this.numberFormatter = this.numberFormatter.bind(this);
    this.numberFormatterHideIfHaveSubpayments =
    this.numberFormatterHideIfHaveSubpayments.bind(this);
    this.dateFormatter = this.dateFormatter.bind(this);
    this.outstandingFormatter = this.outstandingFormatter.bind(this);
    this.expensesTypeFormatter = this.expensesTypeFormatter.bind(this);
    this.counterpartyFormatter = this.counterpartyFormatter.bind(this);
    this.documentTypeFormatter = this.documentTypeFormatter.bind(this);
    this.textFormatter = this.textFormatter.bind(this);
    this.textMultiFormatter = this.textMultiFormatter.bind(this);
    this.deleteButton = this.deleteButton.bind(this);
    this.contractNumberFormatter = this.contractNumberFormatter.bind(this);
    this.paymentAmountFormatter = this.paymentAmountFormatter.bind(this);
    this.bankingCostFormatter = this.bankingCostFormatter.bind(this);
    this.filterExpenseData = this.filterExpenseData.bind(this);
    this.isTotalRow = this.isTotalRow.bind(this);
    this.tableClassName = this.tableClassName.bind(this);
    this.canEditTopApprove = this.canEditTopApprove.bind(this);
    this.paymentMethodFormatter = this.paymentMethodFormatter.bind(this);

    this.productFormatter = this.productFormatter.bind(this);
    this.dealPriceFormatter = this.dealPriceFormatter.bind(this);
    this.dealFreightFormatter = this.dealFreightFormatter.bind(this);
    this.dealBuyerFormatter = this.dealBuyerFormatter.bind(this);
    this.transportNameFormatter = this.transportNameFormatter.bind(this);
    this.blQuantityFormatter = this.blQuantityFormatter.bind(this);
    this.remarksFormatter = this.remarksFormatter.bind(this);
    this.tableClassName = this.tableClassName.bind(this);

    this.productFormatter = this.productFormatter.bind(this);
    this.dealPriceFormatter = this.dealPriceFormatter.bind(this);
    this.dealFreightFormatter = this.dealFreightFormatter.bind(this);
    this.dealBuyerFormatter = this.dealBuyerFormatter.bind(this);
    this.transportNameFormatter = this.transportNameFormatter.bind(this);
    this.remarksFormatter = this.remarksFormatter.bind(this);
    this.simpleTextFormatter = this.simpleTextFormatter.bind(this);
    this.simpleTextFormatterWithCurrency = this.simpleTextFormatterWithCurrency.bind(this);
    this.vesselNameTextFormatter = this.vesselNameTextFormatter.bind(this);

    this.handleAddPayment = this.handleAddPayment.bind(this);
    this.handleAddSubPayment = this.handleAddSubPayment.bind(this);
    this.handleAddSubPartial = this.handleAddSubPartial.bind(this);
    this.handleRemovePayment = this.handleRemovePayment.bind(this);
    this.handleSavePayment = this.handleSavePayment.bind(this);

    this.canDelete = this.canDelete.bind(this);
    this.calcValue = this.calcValue.bind(this);
    this.hasSubpayments = this.hasSubpayments.bind(this);
    this.hasL2Payments = this.hasL2Payments.bind(this);
    this.isSubpayment = this.isSubpayment.bind(this);
    this.isSubpartial = this.isSubpartial.bind(this);
    this.isSubpartialTable = this.isSubpartialTable.bind(this);
    this.isFinancialMode = this.isFinancialMode.bind(this);
    this.isTodaysReport = this.isTodaysReport.bind(this);
    this.isTransportPayments = this.isTransportPayments.bind(this);
    this.isDirty = this.isDirty.bind(this);
    this.checkIfApprovedAvailable = this.checkIfApprovedAvailable.bind(this);
    this.checkIfApproved = this.checkIfApproved.bind(this);
    this.validateDueAmount = this.validateDueAmount.bind(this);
    this.validationClassname = this.validationClassname.bind(this);
    this.updateDealPayment = this.updateDealPayment.bind(this);
    this.rebuildExpenses = this.rebuildExpenses.bind(this);
    this.formPaymentExpense = formPaymentExpense.bind(this);
    this.openModalDelete = this.openModalDelete.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
    this.renderAdditionalElements = this.renderAdditionalElements.bind(this);
    this.yesButtonDelete = this.yesButtonDelete.bind(this);
    this.filterData = this.filterData.bind(this);
    this.permissionFilter = this.permissionFilter.bind(this);
    this.validatePaymentAmountModal = this.validatePaymentAmountModal.bind(this);
    this.resolveContractNumberTitle = this.resolveContractNumberTitle.bind(this);
    this.resolveVesselName = this.resolveVesselName.bind(this);
    this.initBankingExpenses = this.initBankingExpenses.bind(this);
    this.getPaymentIndex = this.getPaymentIndex.bind(this);
    this.hasSubpaymentsByIdx = this.hasSubpaymentsByIdx.bind(this);
    this.sortDueDateInitial = this.sortDueDateInitial.bind(this);
    this.getCounterpartyDicts = this.getCounterpartyDicts.bind(this);
    this.vesselNameFormatter = this.vesselNameFormatter.bind(this);
    this.getTable = this.getTable.bind(this);
    this.getFinTable = this.getFinTable.bind(this);
    this.getNotFinTable = this.getNotFinTable.bind(this);
    this.getPaginationOptions = this.getPaginationOptions.bind(this);
    this.getPaymentAmount = this.getPaymentAmount.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.hideAlert = this.showAlert.bind(this, undefined);
    this.dirty = new Map();
    this.excludeExpenseTypes = new Set();
    this.initialSortSet = false;
    this.vesselName = '';

    this.changeViewMode = this.changeViewMode.bind(this);
    let viewMode = BRIEF_MODE;
    if (props.viewMode) {
      viewMode = props.viewMode;
    } else {
      viewMode = this.isFinancialMode(props) ? BRIEF_MODE : DETAILED_MODE;
    }
    this.state = {
      nonSubPartialPayments: [],
      subPartialPayments: [],
      showModal: false,
      showModalDelete: false,
      subPartialIdx: undefined,
      maxPayment: undefined,
      modalError: undefined,
      viewMode,
      showBulkPaymentModal: false,
      idxForBulkPayment: undefined,
      restrictedExpenseIds: undefined,
    };
    this.dataLoading = true;
    this.baseOptions = {
      expandBy: 'column',
      expanding: expandHack,
      paginationSize: 7,
      paginationShowsTotal: true,
      paginationPosition: 'top',
      onSortChange,
      searchDelayTime: 150,
      clearSearch: true,
    };
    this.finOptions = { ...this.baseOptions, ...{
      defaultSortName: 'resolvedDueDate',
      defaultSortOrder: 'desc' } };
  }

  componentWillMount() {
    loadAddDicts();
    loadAllDeals();
    if (!this.props.subpayment && !this.props.subpartial) {
      if (this.props.isClosed) {
        locationFallThroughInitial('Closed payments', '/deals/closedpayments');
      } else if (this.props.showCredit) {
        locationFallThroughInitial('Incoming payments', '/deals/inpayments');
      } else if (this.props.showDebit) {
        locationFallThroughInitial('Outgoing payments', '/deals/outpayments');
      }
    }
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return;
    }
    const restrictedExpenseIds = this.fillRestrictedExpenseIds(this.props);
    this.initBankingExpenses(this.props, restrictedExpenseIds);
    this.setState(this.prepareData(this.props, true));
    this.dataLoading = false;
  }

  componentWillReceiveProps(props) {
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return;
    }
    const restrictedExpenseIds = this.fillRestrictedExpenseIds(props);
    if (props.viewMode != this.props.viewMode) {
      this.setState({ viewMode: props.viewMode });
    }
    this.initBankingExpenses(props, restrictedExpenseIds);
    this.setState(this.prepareData(props, this.dataLoading || props.saving != this.props.saving ||
      this.isFinancialMode() || this.isTodaysReport()));
    this.dataLoading = false;
  }

  shouldComponentUpdate(nextProps, nextStates) {
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return false;
    }
    if (this.isFinancialMode() || this.isTodaysReport()) {
      return true;
    }
    // смотрим изменения в state
    if (this.state.mode != nextStates.mode || nextProps.viewMode != this.props.viewMode
    || JSON.stringify(this.state.nonSubPartialPayments) !=
 JSON.stringify(nextStates.nonSubPartialPayments)
    || JSON.stringify(this.state.subPartialPayments) !=
 JSON.stringify(nextStates.subPartialPayments)
    || this.state.restrictedExpenseIds != nextStates.restrictedExpenseIds
    || this.state.viewMode != nextStates.viewMode
    || this.state.showModalDelete != nextStates.showModalDelete
    || this.state.showEditContractPayment != nextStates.showEditContractPayment
    || this.state.showBulkPaymentModal != nextStates.showBulkPaymentModal
    || this.state.showTopManagerModal != nextStates.showTopManagerModal
    || this.props.contractNumber != nextProps.contractNumber
    || this.props.contractor != nextProps.contractor
    || this.props.currency != nextProps.currency
    || this.props.parentPayments != nextProps.parentPayments
    || this.props.datchex != nextProps.datchex
    || this.props.expensestypes != nextProps.expensestypes
    || this.props.topmanagers != nextProps.topmanagers
    || this.props.showDebit != nextProps.showDebit
    || this.props.showCredit != nextProps.showCredit
    || this.props.isClosed != nextProps.isClosed
    || this.props.expensestypes != nextProps.expensestypes
    || this.props.currentDealJSON != nextProps.currentDealJSON
    || this.state.showApproveAlert != nextStates.showApproveAlert) {
      return true;
    }
    return false;
  }
  // eslint-disable-next-line
  initBankingExpenses(props, restrictedExpenseIds) {
    if (props.payments && !this.isSubpayment(props) &&
    restrictedExpenseIds && !this.expensesInit) {
      const paymentsWithBanking = extractBankingPayment(props.payments, restrictedExpenseIds);
      paymentsWithBanking.forEach((p, index) =>
        this.rebuildExpenses(index, p, props, true, restrictedExpenseIds, paymentsWithBanking));
      this.expensesInit = true;
    }
  }

  fillRestrictedExpenseIds(props) {
    if ((this.state.restrictedExpenseIds == undefined)
     && props.expensestypes && props.expensestypes.size > 0) {
      let restrictedExpenseIds = new List();
      restrictedExpenseIds = restrictedExpenseIds.push(props.expensestypes.find(
        e => e.get('name').toLowerCase() == FREIGHT_EXPENSES_TYPE, this, new Map())
        .get('id', ''))
        .push(props.expensestypes.find(
          e => e.get('name').toLowerCase() == PRODUCT_EXPENSES_TYPE, this, new Map())
          .get('id', ''));
      this.setState({ restrictedExpenseIds });
      return restrictedExpenseIds;
    }
    return this.state.restrictedExpenseIds;
  }

  showAlert(buttonId) {
    this.setState({ showApproveAlert: buttonId });
  }

  onTopManagerSelect(topManagerId, idx, note) {
    this.closeTopManagerModal();
    this.updateDealPayment(
      idx,
      this.paymentPreprocessorTopApproverPending(
        this.props,
        idx,
        topManagerId,
        note),
    );
  }

  closeModal() {
    this.setState({ showModal: false, subPartialIdx: undefined, row: undefined,
      isNewPayment: undefined, maxPayment: undefined, modalError: undefined });
  }
  openModal(paymentIdx, row = {}) {
    // eslint-disable-next-line
    const { bankingCost, paymentAmount, paymentDate, ...newRow } = row;
    this.setState({ showModal: true, subPartialIdx: paymentIdx, row: newRow, isNewPayment: true,
      maxPayment: row.outstanding, modalError: undefined });
  }
  openModalEdit(idx, row) {
    this.setState({ showModal: true, subPartialIdx: idx, row, isNewPayment: false,
      modalError: undefined });
  }
  isTotalRow(row) {
    return row.isTotalDebitRow || row.isTotalCreditRow;
  }

  canDelete(idx) {
    if (this.props.disabled) {
      return false;
    }
    if (this.props.subpartial && this.isFinancialMode()) {
      return true;
    }
    if (this.isFinancialMode()) {
      return false;
    }
    const payment = this.props.payments.get(idx);
    if (paymentHasFinData(payment)) {
      return false;
    }
    if (paymentHasSubpaymentsWithFinData(payment)) {
      return false;
    }
    return true;
  }
  changeViewMode() {
    if (this.state.viewMode == DETAILED_MODE) {
      this.setState({ viewMode: BRIEF_MODE });
    } else {
      this.setState({ viewMode: DETAILED_MODE });
    }
  }
  isSubpayment(props = this.props) {
    return !!props.subpayment;
  }

  isSubpartialTable(props = this.props) {
    return !!props.subpartial;
  }

  isSubpartial(idx) {
    return this.props.payments
      && this.props.payments.get(idx, new Map()).get('isSubPartial');
  }

  hasSubpayments(row, excludeSubPartial = false) {
    return !this.props.subpayment
      && row.payments
      && row.payments.filter(p => (!excludeSubPartial ? p : !p.isSubPartial)).length > 0;
  }

  hasSubpaymentsByIdx(idx, excludeSubPartial = false) {
    return !this.props.subpayment
      && this.props.payments
      && this.props.payments.getIn([idx, 'payments'])
      && this.props.payments.getIn([idx, 'payments'])
        .filter(p => (!excludeSubPartial ? p : !p.get('isSubPartial'))).size > 0;
  }

  hasL2Payments(row) {
    if (row.payments
      && row.payments.length > 0) {
      let result = false;
      row.payments.forEach(payment => {
        if (payment.isSubPartial != true) {
          result = true;
        }
      });
      return result;
    }
    return false;
  }

  isFinancialMode(props = this.props) {
    return props.mode == 'financial';
  }
  isTodaysReport(props = this.props) {
    return props.mode == 'todaysReport';
  }

  isTransportPayments() {
    return this.props.dealType == 'transport';
  }

  isDirty(row) {
    if (row.payments) {
      return row.isDirty;
    }
    return false;
  }

  validateDueAmount(paymentArg, moreThanZero = false) {
    if (this.isFinancialMode()) {
      return true;
    }
    const payment = paymentArg.get ? paymentArg : fromJS(paymentArg);
    if (!hasSubpaymentsObj(payment)) {
      return true;
    }
    let dueAmount = payment.get('dueAmount') || 0.00;
    payment.get('payments').forEach(p => (dueAmount -= p.get('dueAmount') || 0.00));
    return moreThanZero ? dueAmount > 0 : dueAmount >= 0;
  }
  validationClassname(row) {
    const dueDateTodayClass = row.dueDate &&
      moment(row.dueDate).isSame(moment(), 'day') ? 'payments-today' : '';
    if (this.isTotalRow(row)) {
      return 'payments-row total-row';
    }
    if (this.isFinancialMode()) {
      if (this.state.row && this.state.row.id == row.id) {
        return `payments-row pay-row ${dueDateTodayClass}`;
      }
      return `payments-row ${dueDateTodayClass}`;
    }
    return row.dueAmountValid === false || this.props.parentFailedValidation ?
      'due-amount-invalid' : '';
  }
  validatePaymentAmountModal(e) {
    let value = undefined;
    if (e.target.value) {
      value = parseFloat(e.target.value.replace(/,/g, ''));
    }

    const paymentIdx = this.state.subPartialIdx;
    if (value && (this.state.maxPayment || this.state.maxPayment === 0) &&
      this.state.maxPayment < value) {
      this.setState({ modalError: 'Payment amount cannot exceed outstanding amount' });
      return;
    }
    if (value && this.state.row && paymentIdx != undefined) {
      let paymentToCalcOutstandingFrom = undefined;
      if (this.state.row.isSubPartial) {
        if (this.props.parentPayments && (this.props.paymentIdx || this.props.paymentIdx === 0)) {
          paymentToCalcOutstandingFrom = this.props.parentPayments
            .get(this.props.paymentIdx, new Map());
        }
      } else {
        if (this.props.payments) {
          paymentToCalcOutstandingFrom = this.props.payments.get(paymentIdx, new Map());
        }
      }
      if (paymentToCalcOutstandingFrom) {
        const totalOutstanding = calcOutstanding(paymentToCalcOutstandingFrom);
        const validateAgainst = (parseFloat(this.state.row.paymentAmount) || 0) + totalOutstanding;
        if (validateAgainst < value) {
          this.setState({ modalError: 'Payment amount cannot exceed outstanding amount' });
          return;
        }
      }
    }
    if (this.state.modalError) {
      this.setState({ modalError: undefined });
    }
    this.forceUpdate();
  }

  isExpandableRow(row) {
    return row.payments && row.payments.length > 0;
  }

  expandComponent(row) {
    const isSubPartial = !!(row && row.payments && row.payments.find(p => p.isSubPartial));
    return (
      <div style={{ color: 'black' }}>
        <InternalSubPaymentsContainer
          productIdx={this.props.productIdx}
          paymentIdx={row.paymentIdx}
          parentPaymentIdx={this.props.paymentIdx}
          subpayment
          disabled={this.props.disabled}
          subpartial={isSubPartial}
          saving={this.props.saving}
          payments={fromJS(row.payments)}
          parentPayments={this.props.payments}
          mode={this.props.mode}
          viewMode={this.state.viewMode}
          dealType={this.props.dealType}
          contractNumber={this.props.contractNumber}
          currency={this.props.currency || row.dueAmountCurrency}
          isDebit={this.props.isDebit || row.isDebit}
          isClosed={this.props.isClosed}
          parentFailedValidation={row.dueAmountValid === false || this.props.parentFailedValidation}
        />
      </div>
    );
  }

  paymentPreprocessor(row, name, value) {
    if (row) {
      let payment = fromJS(row);
      payment = payment.set(name, value);
      return payment;
    }
    return undefined;
  }

  paymentPreprocessorTopApproverPending = (props, paymentIdx, value, note) =>
    ({ topManagerApproveState: 'PENDING',
      topApproverLinkExpireTime: null,
      topApprover: value,
      topApproverNote: note })

  paymentPreprocessorExpenseType(value, pmt) {
    const result = pmt || {};
    result.expensesType = value;
    let expensesTypeName = null;
    if (value || value === 0) {
      expensesTypeName = this.props.expensestypes.find(e => e.get('id') == value, this, new Map())
        .get('name', '').toLowerCase();
      if (PRODUCT_EXPENSES_TYPE == expensesTypeName) {
        result.isDebit = this.props.dealType == 'purchase';
      }
    }
    return result;
  }

  filterExpenseData(data) {
    return filterExpense(data, this.props.dealType);
  }

  checkIfApprovedAvailable(rowArg, parent, props = this.props) {
    const row = rowArg.get ? rowArg.toJS() : rowArg;
    let parentElement = parent || row;
    if (parentElement.get) {
      parentElement = parentElement.toJS();
    }
    const alerts = [];
    if (!row) {
      return { available: false };
    }
    if (!parentElement.documentNumber) {
      alerts.push('Missing document number');
    }
    if (!parentElement.documentType && parentElement.documentType !== 0) {
      alerts.push('Missing document type');
    }
    if (!parentElement.expensesType && parentElement.expensesType !== 0) {
      alerts.push('Missing type');
    }
    if (!((row.isCustomContractPayment && row.dueDateAnchorType != 'DATE') || row.dueDate)) {
      alerts.push('Missing due date');
    }
    if (!props.contractNumber && !row.contractNumber) {
      alerts.push('Missing contract number');
    }
    if (!((row.isCustomContractPayment && row.fullCostType != 'VALUE') || row.dueAmount)) {
      alerts.push('Missing due amount');
    }

    return { available: alerts.length == 0, alerts: alerts.length > 0 ? alerts : undefined };
  }

  checkIfApproved(rowArg) {
    if (!rowArg) {
      return false;
    }
    const row = rowArg.get ? rowArg : fromJS(rowArg);
    if (paymentHasSubpaymentsWithFinData(row)) {
      return true;
    }
    return !!(row.get('approve') ||
    row.get('payments', new List()).find(p => this.checkIfApproved(p)));
  }

  getPaymentIndex(row, idx) {
    if (this.isFinancialMode()) {
      return this.isSubpayment() ? idx : row.paymentIdx;
    }
    return idx;
  }

  deleteButton(contractData, row, formatExtraData, idx) {
    if (this.props.disabled || this.isTotalRow(row)) {
      return '';
    }
    const arg1 = this.getPaymentIndex(row, idx);
    const canDelete = this.canDelete(this.getPaymentIndex(row, idx));
    const updateCheck = `${canDelete}_${this.props.saving}_${row.id}_${arg1}`;
    return (<CustomCell
      value={updateCheck}
      data={
        <div id={`actions-delete-${idx}-${this.isDirty(row)}`}>
          {canDelete ?
            <div>
              <ButtonWithFuncBound
                id="deletePayment"
                bsStyle="link"
                disabled={this.props.saving}
                style={{ padding: '4px 5px 3px 5px', cursor: 'pointer' }}
                className="btn-link-no-underline-on-hover"
                boundFunc={this.openModalDelete}
                args={[arg1, row.id]}
              >
                <img
                  className={'payments-table-small-icon'}
                  src={trash}
                  alt={'Delete'}
                  title={'Delete'}
                />
              </ButtonWithFuncBound>
            </div>
            : ''}
        </div>}
    />);
  }

  canEdit() {
    return false;
  }

  addSubPartialPaymentFormatter(contractData, row, formatExtraData, idx) {
    if (this.isTotalRow(row) || (!row.approve && (this.props.isDebit || row.isDebit))) {
      return '';
    }
    const show = !this.hasL2Payments(row) && !this.isSubpartial(idx) &&
      row.outstanding && row.outstanding >= 1;
    const arg1 = this.getPaymentIndex(row, idx);
    const updateCheck = `${show}_${this.props.saving}_${arg1}_${JSON.stringify(row)}`;
    // eslint-disable-next-line
    const {key, ...rowWithoutKey} = row;
    return (<CustomCell
      value={updateCheck}
      data={
        <div id={`actions-addsubpart-${idx}-${this.isDirty(row)}`}>
          {show && validateRoleConfig(['financesViewEditDelete']) ?
            <div>
              <ButtonWithFuncBound
                id="addSubPartial"
                bsStyle="primary"
                disabled={this.props.saving}
                boundFunc={this.openModal}
                args={[arg1, rowWithoutKey]}
              >
                {this.props.isDebit || row.isDebit ? 'Pay' : 'CR'}
              </ButtonWithFuncBound>
            </div>
            : ''
          }
        </div>}
    />);
  }

  openModalEditAttrs = (paymentIdx, paymentId) => {
    this.setState({ showModalEditAttrs: true, paymentIdx, paymentId });
  };

  closeModalEditAttrs = () => {
    this.setState({ showModalEditAttrs: false, paymentIdx: null,
      paymentId: null, modalEditAttrsParent: null });
  };

  editSubPartialPaymentFormatter(contractData, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    const arg1 = this.getPaymentIndex(row, idx);
    const updateCheck = `${this.getPaymentIndex(row, idx)
    }_${this.props.saving}_${JSON.stringify(row)}`;
    if ((row.isSubPartial || paymentHasFinData(row))
      && validateRoleConfig(['financesViewEditDelete'])) {
      // eslint-disable-next-line
      const {key, ...rowWithoutKey} = row;
      return (<CustomCell
        value={updateCheck}
        data={
          <div id={`actions-addsubpart-${idx}-${this.isDirty(row)}`}>
            <ButtonWithFuncBound
              id="addSubPartial"
              bsStyle="link"
              className="btn-link-no-underline-on-hover"
              disabled={this.props.saving}
              style={{ padding: '4px 5px 3px 5px' }}
              boundFunc={this.openModalEdit}
              args={[arg1, rowWithoutKey]}
            >
              <EditIcon />
            </ButtonWithFuncBound>
          </div>}
      />);
    }
    if (this.canEdit(this.getPaymentIndex(row, idx))) {
      return (<CustomCell
        value={`${this.props.saving}_${row.id}_${arg1}`}
        data={<div id={`actions-edit-${idx}-${this.isDirty(row)}`}>
          <ButtonWithFuncBound
            id="editPayment"
            bsStyle="link"
            disabled={this.props.saving}
            style={{ padding: '4px 5px 3px 5px' }}
            className="btn-link-no-underline-on-hover"
            boundFunc={this.openModalEditAttrs}
            args={[arg1, row.id]}
          >
            <EditIcon />
          </ButtonWithFuncBound>
        </div>}
      />);
    }
    return '';
  }

  resolveContractNumberTitle(row) {
    let title = '';
    if (!this.isSubpayment()) {
      if (this.props.contractNumber) {
        title = this.props.contractNumber;
      }
      if (this.isFinancialMode()) {
        if (row.purchase || row.purchase === 0) {
          const deal = this.props.purchases.find(d => d.get('id') == row.purchase);
          if (deal) {
            title = deal.get('regNumber', '');
          }
        } else if (row.sale || row.sale === 0) {
          const deal = this.props.sales.find(d => d.get('id') == row.sale);
          if (deal) {
            title = deal.get('regNumber', '');
          }
        } else if (row.transport || row.transport === 0) {
          // const deal = this.props.transports.find(d => d.get('id') == row.transport);
          // if (deal) {
          //   title = getTransportTitle(deal);
          // }
        } else {
          title = row.contractNumber;
        }
      }
    }
    return title;
  }

  vesselNameFormatter(value, row, formatExtraData, idx) {
    if (this.isFinancialMode() && !this.props.disabled && (row.transport || row.transport === 0)
      && validateRoleConfig(['allTransports#1'])) {
      return (
        <CustomCell
          value={value}
          data={
            <div
              id={`${formatExtraData}-${idx}`} className="payments-wrapped-text"
              title={value}
            >
              {value}
            </div>}
        />);
    }
    return (<CustomCell
      value={value}
      data={
        <div
          id={`${formatExtraData}-${idx}`} className="payments-wrapped-text"
          title={value}
        >
          {value}
        </div>}
    />);
  }

  contractNumberFormatter(contractData, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    const value = this.isFinancialMode() ?
      row.resolvedContractNumberTitle : this.resolveContractNumberTitle(row);
    return (
      <CustomCell
        value={value}
        data={
          <div
            title={value}
            className="payments-wrapped-text"
            id={`contractNumber-${idx}-${this.isDirty(row)}`}
          >
            {value || ''}
          </div>}
      />);
  }

  expensesTypeFormatter(contractData, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    return (<CustomCell
      value={`${row ? row.expensesType : ''}_${row.hasAnyApproved}`}
      data={<div id={`expensesType-${idx}-${this.isDirty(row)}`}>
        {this.isSubpayment() ? '' :
          <div
            className="bulk-payment-type"
          >
            <RefPicker
              dict="expensestype"
              name={'expensestype'}
              updateDefValueOnEveryChange
              defaultValue={row ? row.expensesType : undefined}
              filterFunc={this.filterExpenseData}
              excludeData={this.excludeExpenseTypes}
              excludeDataNames={EXCLUDE_EXPENSE_TYPE_NAMES}
              disabled={this.props.disabled || this.isFinancialMode()
            || row.hasAnyApproved || row.isCustomContractPayment}
              onChangeFunc={val => {
                // this.setState({ idxForBulkPayment: idx,
                //     selectedBulkTransports: val ? row.bulkPaymentTransports : [],
                //     bulkDischargeTransports: val ? row.bulkDischargeTransports : [],
                //     bulkType: val ? row.bulkPaymentType : BULK_PAYMENT_TYPE.sameType });
                let newPayment = null;
                switch (this.props.dealType) {
                  case 'transport': {
                    const datchex = this.props.owners.find(o =>
                      o.get('name') == 'Datchex', this, new Map());
                    if (this.props.datchex && datchex) {
                      const freightExpenseTypeId = this.props.expensestypes
                        .find(elem => elem.get('name').toLowerCase() == FREIGHT_EXPENSES_TYPE,
                          this, new Map()).get('id');
                      if (val && val.value == freightExpenseTypeId
                    && row.counterparty != datchex.get('id')) {
                        newPayment = { value: datchex.get('id'), discriminator: 'owner' };
                      }
                    }
                    break;
                  }
                  case 'purchase':
                  case 'sale':
                  {
                    const productExpenseTypeId = this.props.expensestypes
                      .find(elem => elem.get('name').toLowerCase() == PRODUCT_EXPENSES_TYPE,
                        this, new Map()).get('id');
                    if (val && val.value == productExpenseTypeId) {
                      newPayment = { counterparty: this.props.contractor,
                        discriminator: this.props.dealType == 'sale' ?
                          BUYER_REF_PATH : SELLER_REF_PATH };
                    } else {
                      this.props.updateDealPayment(
                        this.getPaymentIndex(row, idx),
                        { paymentMethod: null }
                      );
                    }
                    break;
                  }
                  default:
                    break;
                }
                this.updateDealPayment(
                  this.getPaymentIndex(row, idx),
                  this.paymentPreprocessorExpenseType(val ? val.value : undefined, newPayment),
                );
              }}
            />
          </div>
        }
      </div>}
    />);
  }
  getCounterpartyDicts() {
    if (this.isFinancialMode()) {
      return `${dictList},${COMMONCOUNTERPARTIES_REF_PATH}`;
    }
    return `${dictList},${TRADE_COUNTERPARTIES_REF_PATH}`;
  }
  counterpartyFormatter(contractData, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return (<div
        id="totalLabel" style={{
          borderRight: 'thin solid rgb(211, 211, 211)',
          alignItems: 'center',
          justifyContent: 'flex-end',
          display: 'flex',
          margin: '-1px -2px -1px -2em',
          height: 32,
          padding: 4 }}
        className="payments-total"
      >
        {// eslint-disable-next-line
        row.hideTotalTitle ? '' :
            row.isTotalDebitRow ? 'Total debit' : 'Total credit'
        }
      </div>);
    }
    const freightExpenseTypeId = this.props.expensestypes
      .find(elem => elem.get('name').toLowerCase() == FREIGHT_EXPENSES_TYPE,
        this, new Map()).get('id');
    const isFreight = freightExpenseTypeId && row.expensesType == freightExpenseTypeId;
    let availableDicts = this.getCounterpartyDicts();
    if (isFreight && this.props.dealType == 'transport') {
      availableDicts = `${VESSEL_BROKER_REF_PATH},${OWNER_REF_PATH}`;
    }
    const dictValuesFilter = (elem) => {
      switch (elem.discriminator) {
        case BUYER_REF_PATH:
        case SELLER_REF_PATH:
          return elem.value == this.props.contractor;
        default:
          return true;
      }
    };
    const expensesType = this.props.expensestypes.find(elem => elem.get('id') == row.expensesType);
    const isExpenseTypeContractPayment = expensesType &&
    expensesType.get('name', '').toLowerCase() == PRODUCT_EXPENSES_TYPE;
    let isContractPayment = false;
    if (this.props.dealType == 'purchase' && isExpenseTypeContractPayment) {
      availableDicts = SELLER_REF_PATH;
      isContractPayment = true;
    } else if (this.props.dealType == 'sale' && isExpenseTypeContractPayment) {
      availableDicts = BUYER_REF_PATH;
      isContractPayment = true;
    }
    let defaultValue = row ? row.counterparty : undefined;
    if (isContractPayment) {
      defaultValue = this.props.contractor;
    }
    if (this.props.owners && this.props.datchex && isFreight) {
      defaultValue = this.props.owners.find(o =>
        o.get('name') == 'Datchex', this, new Map()).get('id');
    }
    const updateFunc = (val) => {
      this.updateDealPayment(
        idx,
        { counterparty: val ? val.value : undefined,
          discriminator: val ? val.discriminator : undefined },
      );
    };
    return (<CustomCell
      value={`${defaultValue}_${row.hasAnyApproved || isContractPayment}
_${isFreight && this.props.datchex}`}
      data={<div
        id={`counterparty-${idx}-${this.isDirty(row)}`}
        key={`${row.expensesType}_${row.counterparty}`}
      >
        {this.isSubpayment() ? '' :
          <CounterpartyPicker
            dicts={availableDicts}
            updateDefValueOnEveryChange
            filterFunc={dictValuesFilter}
            addButtonDict={row.expensesType || row.expensesType === 0 ?
              { path: TRADE_COUNTERPARTIES_REF_PATH, name: TRADE_COUNTERPARTIES_NAME } : undefined}
            onBeforeAddDictValue={(refDto) =>
              ({ ...refDto, expensesType: row.expensesType })}
            name="counterparty"
            disabled={this.props.disabled || this.isFinancialMode()
          || row.hasAnyApproved || isContractPayment
          || (isFreight && this.props.datchex) || this.isTodaysReport()}
            clearOnDisabledSwitch={isContractPayment}
            defaultValue={defaultValue}
            onChangeFunc={updateFunc}
          />
        }
      </div>}
    />);
  }
  documentTypeFormatter(contractData, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    return (<CustomCell
      value={`${row && !this.isSubpayment() ? row.documentType : undefined}_${row.hasAnyApproved}`}
      data={<div id={`documentType-${idx}-${this.isDirty(row)}`}>
        {this.isSubpayment() ? '' :
          <RefPicker
            dict="documenttype"
            name={'documenttype'}
            updateDefValueOnEveryChange
            defaultValue={row ? row.documentType : undefined}
            disabled={this.props.disabled || this.isFinancialMode() || row.hasAnyApproved}
            onChangeFunc={val => {
              this.updateDealPayment(
                this.getPaymentIndex(row, idx),
                { documentType: val ? val.value : undefined }
              );
            }}
          />
        }
      </div>}
    />);
  }

  bankFormatter(documentData, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    return (<CustomCell
      value={`${row ? row.bank : undefined}
        ${row.hasAnyApproved}
        ${!this.hasSubpayments(row, true)}`}
      data={<div id={`bank-${idx}-${this.isDirty(row)}`}>
        {!paymentHasFinData(row) && this.hasSubpayments(row) ? '' :
          <RefPicker
            dict="bank"
            name="bank"
            noAddButton
            defaultValue={row ? row.bank : undefined}
            updateDefValueOnEveryChange={this.isFinancialMode()}
            disabled={this.props.disabled || this.isFinancialMode() || row.hasAnyApproved}
            onChangeFunc={val => {
              this.updateDealPayment(
                this.getPaymentIndex(row, idx),
                { bank: val ? val.value : undefined },
              );
            }}
          />
        }
      </div>}
    />);
  }

  invoiceFormatter(documentData, row, formatExtraData, idx) {
    if (this.isTotalRow(row) || row.isSubPartial) {
      return '';
    }
    return this.isFinancialMode() && row.document ?
      <CustomCell
        value={this.props.disabled}
        data={
          <div id={`document-${idx}-${this.isDirty(row)}`}>
            <Button
              style={{ textOverflow: 'ellipsis',
                wordBreak: 'break-all',
                overflow: 'hidden',
                whiteSpace: 'normal',
                height: '2em',
                padding: '4px 12px',
              }}
              bsStyle="link"
              id="downloadFile"
              disabled={this.props.disabled}
              className="btn-link-no-underline-on-hover"
              href={`/download/api/${row.document.uuid}`}
            >
              <img
                src={attach}
                alt={row.document.regNumber || row.document.originalName}
                className={'payments-table-small-icon'}
                title={row.document.regNumber || row.document.originalName}
              />
            </Button>
          </div>}
      />
      :
      <div id={`document-${idx}-${this.isDirty(row)}`}>
        <FileDocument
          type="USUAL"
          disabled={this.props.disabled || this.isFinancialMode()}
          productIdx={this.props.productIdx}
          parentPaymentIdx={this.props.paymentIdx}
          paymentIdx={row.paymentIdx}
          dealType={this.props.dealType}
        />
      </div>;
  }

  approveFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row) ||
      (!(this.props.isDebit || row.isDebit) && (row.outstanding ||
        ((row.fullCostType == 'BALANCE' || row.fullCostType == 'PERCENT') && !row.paymentAmount)
      )
      )) {
      return '';
    }
    let available = true;
    if (!row.isSubPartial) {
      if (row.approve && paymentHasFinData(row)) {
        available = false;
      } else {
        if (value) {
          available = true;
        } else {
          available = row.approvedAvailable;
        }
      }
    }
    if (!(this.props.isDebit || row.isDebit)) {
      available = false;
    }
    let key = 'approved';
    let icon = <ApprovedIcon />;
    if (!value) {
      key = 'unapproved';
      icon = <UnapprovedIcon />;
    }
    if ((value || !(this.props.isDebit || row.isDebit)) &&
     ((!row.outstanding || row.outstanding < 1) && row.dueAmount)) {
      key = 'payed';
      icon = <PayedIcon />;
    }
    return (
      <CustomCell
        value={`${key}_${available}_${row.approveAlerts && row.approveAlerts.length}`}
        data={
          <div id={`approve-${idx}-${this.isDirty(row)}`}>
            <input
              type="checkbox"
              defaultChecked={value}
              style={{ display: 'none' }}
            />
            {!this.hasSubpayments(row, true) && !row.isSubPartial
              ?
              <span>
                <OverlayTrigger
                  rootClose
                  container={this}
                  trigger={row.approveAlerts && row.approveAlerts.length ? 'click' : null}
                  overlay={
                    <Popover className="payments-alert-popover" id="approveAlerts">
                      <span style={{ float: 'left' }} >
                        {row.approveAlerts && row.approveAlerts.map(e => <div>{e}</div>)}
                      </span>
                    </Popover>
                  }
                >
                  <Button
                    id={`approve_button_${row.paymentIdx}_${idx}`}
                    style={{ padding: 0,
                      opacity: row.approveAlerts && row.approveAlerts.length ? 0.7 : 1 }}
                    onClick={() => {
                      /* eslint-enable */
                      if (this.props.disabled || !available) {
                        this.showAlert(`${row.paymentIdx}_${idx}`);
                      } else {
                        this.updateDealPayment(
                          this.getPaymentIndex(row, idx),
                          { approve: !value },
                        );
                        this.forceUpdate();
                      }
                    }}
                  >
                    {icon}
                  </Button>
                </OverlayTrigger>
              </span>
              : ''
            }
          </div>}
      />
    );
  }

  finApproveFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row) || (!(this.props.isDebit || row.isDebit) && row.outstanding)) {
      return '';
    }
    let paymentState = 'approved';
    let icon = <ApprovedIcon />;
    if (!value) {
      paymentState = 'unapproved';
      icon = <UnapprovedIcon />;
    }
    if ((value || !(this.props.isDebit || row.isDebit)) &&
    (!row.outstanding || row.outstanding < 1) && row.dueAmount) {
      paymentState = 'payed';
      icon = <PayedIcon />;
    }
    return (
      <CustomCell
        value={paymentState}
        data={
          <div id={`approve-${idx}-${this.isDirty(row)}`}>
            {!this.hasSubpayments(row, true) && !row.isSubPartial
              ?
              <Button
                disabled
                style={{ padding: 0 }}
              >
                {icon}
              </Button>
              : ''
            }
          </div>}
      />
    );
  }

  textFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    return (
      <CustomCell
        value={`${value}_${formatExtraData == 'documentNumber' && row.hasAnyApproved}`}
        data={<div id={`text-${formatExtraData}-${idx}-${this.isDirty(row)}`}>
          <FormControl
            value={value || undefined}
            disabled={this.props.disabled || this.isFinancialMode() ||
            (formatExtraData == 'documentNumber' && row.hasAnyApproved)}
            onChange={(e) => {
              this.updateDealPayment(
                this.getPaymentIndex(row, idx),
                { [formatExtraData]: e.target.value },
              );
            }}
          />
        </div>}
      />
    );
  }

  textMultiFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row) || row.isSubPartial) {
      return '';
    }
    return (
      <CustomCell
        value={value}
        data={<div id={`multitext-${formatExtraData}-${idx}-${this.isDirty(row)}`}>
          <FormControl
            style={{ resize: 'none' }}
            componentClass="textarea"
            value={value || undefined}
            rows={2}
            disabled={this.props.disabled || this.isFinancialMode()}
            onChange={(e) => {
              this.updateDealPayment(
                this.getPaymentIndex(row, idx),
                { [formatExtraData]: e.target.value },
              );
            }}
          />
        </div>}
      />
    );
  }
  debitCreditFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    const arg1 = this.getPaymentIndex(row, idx);
    const arg2 = { isDebit: !value };
    return (
      <CustomCell
        value={`${value}_${row.hasAnyApproved}`}
        data={<div id={`dbcr-${idx}-${this.isDirty(row)}`}>
          {this.isSubpayment() ? '' :
            <Row
              style={{
                margin: '0px',
              }}
            >
              <ButtonWithFuncBound
                bsStyle={value ? 'secondary' : 'primary'}
                style={{ padding: 0 }}
                disabled={this.props.disabled || this.isFinancialMode() || row.hasAnyApproved}
                boundFunc={this.updateDealPayment}
                args={[arg1, arg2]}
              >
                {value ?
                  <MinusIcon />
                  :
                  <PlusIcon />
                }
              </ButtonWithFuncBound>
            </Row>
          }
        </div>}
      />
    );
  }

  finDebitCreditFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    return (
      <CustomCell
        value={value}
        data={
          <div id={`dbcr-${idx}-${this.isDirty(row)}`}>
            {this.isSubpayment() ? '' :
              <Row
                style={{
                  margin: '0px',
                }}
              >
                <Button
                  bsStyle={value ? 'secondary' : 'primary'}
                  style={{ padding: 0 }}
                  disabled
                >
                  {value ?
                    <MinusIcon />
                    :
                    <PlusIcon />
                  }
                </Button>
              </Row>
            }
          </div>}
      />
    );
  }

  calcValue(value, formatExtraData, idx) {
    if (this.hasSubpayments(idx)) {
      const subpayments =
        this.props.payments
          ? this.props.payments.getIn([idx, 'payments'], new List())
          : new List();
      let result = 0.0;
      subpayments.forEach((sp) => {
        result += sp.get(formatExtraData);
      });
      return result;
    }
    return value;
  }

  paymentMethodFormatter(value, row, formatExtraData, idx) {
    const expensesType = this.props.expensestypes.find(elem => elem.get('id') == row.expensesType);
    const isExpenseTypeContractPayment = expensesType &&
      expensesType.get('name', '').toLowerCase() == PRODUCT_EXPENSES_TYPE;
    if (isExpenseTypeContractPayment) {
      return (
        <CustomCell
          value={`${value}_${row.hasAnyApproved}`}
          data={<RefPicker
            dict="paymentmethod" name="paymentMethod"
            updateDefValueOnEveryChange
            defaultValue={value}
            disabled={this.props.disabled || this.isFinancialMode() || row.hasAnyApproved}
            onChangeFunc={val => {
              this.updateDealPayment(
                this.getPaymentIndex(row, idx),
                { paymentMethod: val ? val.value : undefined }
              );
            }}
          />}
        />
      );
    }
    return '';
  }

  dueAmountFormatter(value, row, formatExtraData, idx) {
    if (this.isTodaysReport()) {
      if (value && row) {
        return `
        ${formatCurrency(this.props.currency || row.dueAmountCurrency)} ${formatNumberZeroIfNull(
  value, '0,0.00')}`;
      }
    }
    const isTotalRow = this.isTotalRow(row);
    const showAddSumpayment = !this.isTodaysReport() && !this.isSubpayment() &&
      !this.isFinancialMode() && !row.approve && row.outstanding && !row.isCustomContractPayment &&
       this.validateDueAmount(row, true);
    // eslint-disable-next-line
    const {key, ...rowWithoutKey} = row;
    const addSubPaymentButton = (<CustomCell
      value={`${rowWithoutKey}_${showAddSumpayment}_${idx}`}
      data={<div
        id={`actions-addsub-${idx}-${this.isDirty(row)}`}
        style={showAddSumpayment ? { marginRight: -20, marginLeft: 5 } : {}}
      >
        {showAddSumpayment && !this.props.disabled ?
          <div>
            <ButtonWithFuncBound
              id="addSubPayment"
              bsStyle="link"
              boundFunc={this.handleAddSubPayment}
              args={[rowWithoutKey, idx]}
              style={{ padding: 0, border: 0, height: 28 }}
            >
              <Glyphicon
                style={{ cursor: 'pointer', fontSize: 28 }}
                glyph="indent-left"
                title="Add subpayment"
              />
            </ButtonWithFuncBound>
          </div>
          : ''
        }
      </div>}
    />);
    return (
      this.isSubpartialTable() &&
       (formatExtraData == 'dueAmount' || formatExtraData == 'estimatedDueAmount') ?
        <div /> :
        <CustomCell
          value={`${row.fullCostType}_${row.isCustomContractPayment}
_${this.props.currency || row.dueAmountCurrency}
_${this.props.disabled
  || this.isFinancialMode()
  || row.hasAnyApproved}_${value}`}
          data={<div
            className="dueAmount"
            id={`dueAmount-${formatExtraData}-${idx}-${this.isDirty(row)}`}
            style={row.isCustomContractPayment ? { marginRight: '-20px' } : {}}
          >
            {this.isSubpayment() || isTotalRow ||
          row.fullCostType == 'BALANCE' || row.fullCostType == 'PERCENT' ?
              <span
                style={{ display: 'flex', alignItems: 'center',
                  paddingRight: 20, paddingLeft: 3 }}
              >
                {formatCurrency(this.props.currency || row.dueAmountCurrency)}
              </span> :
              <div key={this.props.currency || row.dueAmountCurrency}>
                <CurrencyInput
                  name="dueAmountCurrency"
                  defaultValue={this.props.currency || row.dueAmountCurrency}
                  noRates
                  disabled={this.props.disabled || row.hasAnyApproved
              || this.isFinancialMode() || this.isSubpayment()
              || this.isTodaysReport() || formatExtraData == 'estimatedDueAmount'
              || row.isCustomContractPayment}
                  onChange={(val) => {
                    this.updateDealPayment(
                      this.getPaymentIndex(row, idx),
                      { dueAmountCurrency: val }
                    );
                  }}
                />
              </div>
            }
            {this.numberFormatter(value, row, formatExtraData, idx, false,
              formatExtraData == 'estimatedDueAmount' ||
            row.isCustomContractPayment)}
            {!isTotalRow ? addSubPaymentButton : ''}
            {row.isCustomContractPayment && <Button
              bsStyle="link"
              disabled={this.props.disabled
              || this.isFinancialMode()
              || row.hasAnyApproved}
              style={{ padding: 5, minHeight: '100%', maxHeight: 20 }}
              onClick={() => this.openDueAmountEdit(idx)}
            >
              <EditIcon />
            </Button>
            }
          </div>}
        />
    );
  }

  paymentAmountFormatter(value, row, formatExtraData, idx) {
    return this.numberFormatter(value, row, formatExtraData, idx, this.hasSubpayments(row, true));
  }
  bankingCostFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row) && !row.bankingCost) {
      return '';
    }
    if (paymentHasFinData(row)) {
      return this.numberFormatter(value, row, formatExtraData, idx);
    }
    return this.numberFormatter(value, row, formatExtraData, idx, this.hasSubpayments(row));
  }

  numberFormatterHideIfHaveSubpayments(value, row, formatExtraData, idx) {
    return this.numberFormatter(value, row, formatExtraData, idx, this.hasSubpayments(row));
  }

  numberFormatter(value, row, formatExtraData, idx, hide = false, disabled = false) {
    const currency = this.props.currency || row.dueAmountCurrency;
    return (
      <div id={`number-${formatExtraData}-${idx}-${this.isDirty(row)}`}>
        {hide ? '' :
          <Row
            style={{
              margin: '0px',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FancyInput
              className="form-control"
              currency={formatExtraData == 'dueAmount' || 'estimatedDueAmount' ?
                undefined : formatCurrency(currency || 'USD')}
              style={{ textAlign: 'right' }}
              fraction={2}
              positive
              negative={false}
              thousand
              type="number"
              value={formatExtraData == 'dueAmount' || 'paymentAmount' ?
                value : this.calcValue(value, formatExtraData, this.getPaymentIndex(row, idx))}
              disabled={
                disabled ||
              this.props.disabled ||
              this.isTodaysReport() ||
              (row.hasAnyApproved && formatExtraData == 'dueAmount') ||
              (!this.isFinancialMode() && formatExtraData == 'bankingCost') ||
              (!this.isFinancialMode() && formatExtraData == 'paymentAmount') ||
              this.isFinancialMode() || this.isTotalRow(row)
              }
              onChange={(e, val) => {
                this.updateDealPayment(
                  this.getPaymentIndex(row, idx),
                  { [formatExtraData]: val }
                );
              }}
            />
          </Row>
        }
      </div>
    );
  }

  dueDateFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    return (
      <CustomCell
        value={`${value}_${this.props.disabled}
        ${(!this.isFinancialMode() && formatExtraData == 'paymentDate')}
        ${!this.hasSubpayments(row, true)}
        ${this.isFinancialMode()}
        ${(row.hasAnyApproved && formatExtraData == 'dueDate')}
        ${(row.hasAnyApproved && formatExtraData == 'estimatedDueDate')}
        ${(row.isCustomContractPayment && formatExtraData != 'estimatedDueDate')}
        }`}
        data={<div id={`date-${formatExtraData}-${idx}-${this.isDirty(row)}`}>
          {this.isFinancialMode() ?
            <div className="payments-fin-date">{value}</div>
            : ''}
          {!this.isFinancialMode() && !this.hasSubpayments(row, true)
            ?
            <Row
              style={{
                margin: '0px',
                display: 'flex',
                alignContent: 'stretch',
              }}
            >
              <Col
                xs={row.isCustomContractPayment && formatExtraData != 'estimatedDueDate' ? 9 : 12}
                style={{ padding: 0 }}
              >
                <RequiredFormControl
                  component={DateTimePicker}
                  time={false}
                  format={dateTimePickerFormat}
                  value={value ? new Date(value) : undefined}
                  disabled={this.props.disabled
                  || (!this.isFinancialMode() && formatExtraData == 'paymentDate')
                  || this.isFinancialMode()
                  || (row.hasAnyApproved && formatExtraData == 'dueDate')
                  || (row.hasAnyApproved && formatExtraData == 'estimatedDueDate')
                  || (row.isCustomContractPayment && formatExtraData != 'estimatedDueDate')
                  }
                  onChange={(e, val) => {
                    this.updateDealPayment(
                      this.getPaymentIndex(row, idx),
                      { [formatExtraData]: val }
                    );
                  }}
                />
              </Col>
              <Col
                xs={3}
                style={{ display: row.isCustomContractPayment &&
                formatExtraData != 'estimatedDueDate' ? 'block' : 'none',
                padding: 0 }}
              >
                <Button
                  bsStyle="link"
                  disabled={this.props.disabled
                || (!this.isFinancialMode() && formatExtraData == 'paymentDate')
                || this.isFinancialMode()
                || row.hasAnyApproved}
                  style={{ padding: 5, minHeight: '100%', maxHeight: 20 }}
                  onClick={() => this.openDueDateEdit(idx)}
                >
                  <EditIcon />
                </Button>
              </Col>
            </Row>
            : ''
          }
        </div>}
      />
    );
  }

  dateFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    return (
      <div id={`date-${formatExtraData}-${idx}-${this.isDirty(row)}`}>
        {this.isFinancialMode() ?
          <div className="payments-fin-date">{value}</div>
          : ''}
        {!this.isFinancialMode() && !this.hasSubpayments(row, true)
          ?
          <Row
            style={{
              margin: '0px',
            }}
          >
            <DateTimePicker
              component={DateTimePicker}
              time={false}
              format={dateTimePickerFormat}
              defaultValue={value ? new Date(value) : undefined}
              disabled={this.props.disabled
                || (!this.isFinancialMode() && formatExtraData == 'paymentDate')
               || this.isFinancialMode()
               || row.hasAnyApproved
              }
              onChange={(e, val) => {
                this.updateDealPayment(
                  this.getPaymentIndex(row, idx),
                  { [formatExtraData]: val }
                );
              }}
            />
          </Row>
          : ''
        }
      </div>
    );
  }

  outstandingFormatter(value, row, formatExtraData, idx) {
    const currency = this.props.currency || row.dueAmountCurrency;
    return (
      <div id={`outstanding-${idx}-${this.isDirty(row)}`}>
        {this.isSubpartialTable() ? '' :
          <FancyInput
            className="form-control"
            currency={formatCurrency(currency || 'USD')}
            style={{ textAlign: 'right' }}
            fraction={2}
            positive
            negative={false}
            thousand
            type="number"
            value={parseFloat(row.outstanding || 0).toFixed(2)}
            disabled
          />
        }
      </div>);
  }
  getProducts(row) {
    const result = [];
    let productIds = new Set();
    if (row.saleProducts) {
      row.saleProducts.forEach(p => {
        if (p.product) {
          productIds = productIds.add(p.product);
        }
      });
    }
    if (row.purchaseProducts) {
      row.purchaseProducts.forEach(p => {
        if (p.product) {
          productIds = productIds.add(p.product);
        }
      });
    }
    productIds.forEach((id) => {
      result.push(<ProductDisplayWrapper
        key={id}
        id={id}
      />
      );
    });
    return result;
  }
  productFormatter(value, row, formatExtraData, idx) {
    const data = this.getProducts(row);
    return (
      <div id={`product-${idx}`} className="payments-wrapped-text">
        {data.map((elem, elemIdx) => <span key={elemIdx}>
          {elem}{elemIdx < data.length - 1 ? ' , ' : ''}
        </span>)}
      </div>);
  }
  getPrice(row, dealType) {
    const products = dealType == 'purchase' ? row.purchaseProducts : row.saleProducts;
    const result = [];
    if (products) {
      products.forEach((p) => {
        if (p.priceValue || p.priceFormula) {
          result.push(
            (`${p.fixedPrice !== false && p.priceValue ?
              `${formatCurrency(p.priceCurrency)} ${formatNumber(p.priceValue, '0,0.00')}`
              : ''} ${p.fixedPrice === false && p.priceFormula ?
              p.priceFormula.substring(0, 140) : ''}`).trim(),
          );
        }
      });
    }
    return result;
  }
  dealPriceFormatter(value, row, formatExtraData, idx) {
    const data = this.getPrice(row, formatExtraData);
    return (
      <div id={`${formatExtraData}-price-${idx}`} className="payments-wrapped-text">
        <span
          // eslint-disable-next-line
          style={{ whiteSpace: 'normal', wordBreak: 'break-all', wordBreak: 'break-word' }}
        >
          {data.join(', ')}
        </span>
      </div>);
  }
  dealFreightFormatter(value, row, formatExtraData, idx) {
    const data = [];
    if (row.transports) {
      row.transports.forEach(t => {
        if (t.freightAmount) {
          data.push(<span>
            {`${formatCurrency(t.freightCurrency)} ${formatNumber(t.freightAmount, '0,0.00')}`}
          </span>);
        }
      });
    }
    return (
      <div id={`freight-${idx}`} className="payments-wrapped-text">
        {data.map((elem, elemIdx) => <span
        /* eslint-disable-next-line */
        style={{ whiteSpace: 'normal', wordBreak: 'break-all', wordBreak: 'break-word' }}
          key={elemIdx}
        >
          {elem}{elemIdx < data.length - 1 ? ',\u00A0' : ''}
        </span>)}
      </div>);
  }
  remarksFormatter(value, row, formatExtraData, idx) {
    const data = [];
    if (row.isDetached && row.notes) {
      data.push(row.notes);
    }
    if (row.purchaseProducts && row.purchaseProducts.length > 0) {
      row.purchaseProducts.forEach(p => {
        if (p.specification) {
          data.push(p.specification);
        }
      });
    }
    if (row.saleProducts && row.saleProducts.length > 0) {
      row.saleProducts.forEach(p => {
        if (p.specification) {
          data.push(p.specification);
        }
      });
    }
    return (
      <div id={`remarks-${idx}`} className="payments-wrapped-text">
        <span
          // eslint-disable-next-line
          style={{ whiteSpace: 'normal', wordBreak: 'break-all', wordBreak: 'break-word' }}
        >
          {data.join(', ')}
        </span>
      </div>);
  }
  dealBuyerFormatter(value, row, formatExtraData, idx) {
    const data = [];
    let buyerIds = new Set();
    if (row.sales) {
      row.sales.forEach(s => { buyerIds = buyerIds.add(s.buyer); });
    }
    buyerIds.forEach(id => {
      if (id || id === 0) {
        data.push(<BuyerDisplayWrapper id={id} key={id} />);
      }
    });
    return (
      <div id={`buyer-${idx}`} className="payments-wrapped-text">
        {data.map((elem, elemIdx) => <span>{elem}{elemIdx < data.length - 1 ? ' , ' : ''}</span>)}
      </div>);
  }
  resolveVesselName(row, props = this.props) {
    let title = '';
    if (!props.transports || props.transports.size == 0) {
      return title;
    }
    if (row.transport || row.transport === 0 || this.isTransportPayments()) {
      const deal = (this.isTransportPayments() && props.currentDeal)
        || props.transports.find(d => d.get('id') == row.transport);
      if (deal) {
        title = getTransportTitle(deal);
      }
      return title;
    }
    let transportIds = new Set();
    if ((props.dealType == 'purchase' || row.purchase || row.purchase === 0) &&
    row.purchaseProducts && row.purchaseProducts.length > 0) {
      row.purchaseProducts.forEach(p => {
        if (p.purchaseLink && p.purchaseLink.length > 0) {
          p.purchaseLink.forEach(l => {
            if (l.transport) {
              transportIds = transportIds.add(l.transport);
            }
          });
        }
      });
    }
    if ((props.dealType == 'sale' || row.sale || row.sale === 0) &&
    row.saleProducts && row.saleProducts.length > 0) {
      row.saleProducts.forEach(p => {
        if (p.saleLink && p.saleLink.length > 0) {
          p.saleLink.forEach(l => {
            if (l.transport) {
              transportIds = transportIds.add(l.transport);
            }
          });
        }
      });
    }
    const data = transportIds
      .map(linkedTrId =>
        props.transports.find(tr => tr.get('id') == linkedTrId))
      .filter(t => t).map(t => getTransportTitle(t));
    if (!data || data.size == 0) {
      this.vesselName = title;
      return title;
    }
    title = data.toJS().join('; ');
    if (!this.isFinancialMode() && !this.isTodaysReport() && title) {
      this.vesselName = title;
    }
    return title;
  }

  getDeal = (row) => {
    const { purchases, sales, transports } = this.props;
    if (row.purchase || row.purchase === 0) {
      return purchases.find(p => p.get('id') == row.purchase);
    } else if (row.sale || row.sale === 0) {
      return sales.find(s => s.get('id') == row.sale);
    }
    return transports.find(t => t.get('id') == row.transport);
  };

  finTypeFormatter(value, row, formatExtraData, idx) {
    let validated = false;
    let url = '';
    let fromTab = '';
    if (this.props.isClosed) {
      fromTab = 'closedpayments';
    } else if (row.isDebit) {
      fromTab = 'outpayments';
    } else {
      fromTab = 'inpayments';
    }
    const deal = this.getDeal(row);
    if (row.purchase || row.purchase === 0) {
      validated = validateRoleConfig(['myDeals#1', 'allDeals#1'], deal);
      url = `/deals/purchase/${row.purchase}?fromTab=${fromTab}`;
    } else if (row.sale || row.sale === 0) {
      validated = validateRoleConfig(['myDeals#1', 'allDeals#1'], deal);
      url = `/deals/sale/${row.sale}?fromTab=${fromTab}`;
    } else if (row.transport || row.transport === 0) {
      validated = validateRoleConfig(['myTransports#1', 'allTransports#1'], deal);
      url = `/deals/transport/${row.transport}?fromTab=${fromTab}`;
    }
    if (validated) {
      return (
        <CustomCell
          value={`${value}_${url}`}
          data={
            <div
              id={`${formatExtraData}-${idx}`} className="payments-wrapped-text"
              title={value}
            >
              <UrlWrappedLink
                title={value}
                bsStyle="link"
                style={{ fontSize: '12px', padding: 0, whiteSpace: 'normal', textAlign: 'left' }}
                url={url}
              >
                {value}
              </UrlWrappedLink>
            </div>}
        />);
    }
    return (
      <CustomCell
        value={value}
        data={
          <div
            id={`${formatExtraData}-${idx}`} className="payments-wrapped-text"
            title={value}
          >
            {value}
          </div>}
      />);
  }

  finUserNameFormatter(value, row, formatExtraData, idx) {
    return (
      <CustomCell
        value={value}
        data={
          <div
            id={`resolvedUser-${idx}`} className="payments-wrapped-text"
            title={row.resolvedUserFullname}
          >
            {value}
          </div>}
      />);
  }

  simpleTextFormatter(value, row, formatExtraData, idx) {
    const className = formatExtraData == 'counterpartyName' ?
      'payments-nowrapped-text' : 'payments-wrapped-text';
    return (
      <CustomCell
        value={value}
        data={
          <div
            id={`${formatExtraData}-${idx}`} className={className}
            title={value}
          >
            {value}
          </div>}
      />);
  }
  simpleTextFormatterWithCurrency(value, row, formatExtraData, idx) {
    if (value && row) {
      return this.simpleTextFormatter(
        `${formatCurrency(this.props.currency || row.dueAmountCurrency)} ${formatNumberZeroIfNull(
          value || 0, '0,0.00')}`, row, formatExtraData, idx);
    }
    return '';
  }
  vesselNameTextFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row)) {
      return '';
    }
    return this.vesselNameFormatter(this.vesselName || value, row, formatExtraData, idx);
  }
  transportNameFormatter(value, row, formatExtraData, idx) {
    const data = [];
    if (row.transports) {
      row.transports.forEach(t => {
        data.push(<span key={t.id} style={{ marginRight: '-5px' }}>
          {formatTransportName(t, true)}</span>);
      });
    }
    return (
      <div id={`transportName-${idx}`} >
        {data.map((elem, elemIdx) => <span key={elemIdx}>
          {elem}{elemIdx < data.length - 1 ? <span>, </span> : ''}
        </span>)}
      </div>);
  }

  blQuantityFormatter(value, row, formatExtraData, idx) {
    let result = <span />;
    let bl = 0;
    if ((row.purchase || row.purchase === 0) && row.purchaseProducts &&
    row.purchaseProducts.length > 0) {
      if (row.purchaseProducts[0].purchaseLink) {
        bl = row.purchaseProducts[0].purchaseLink
          .reduce((sum, l) => sum + parseFloat(l.billLandingQuantity || 0), 0);
      }
      result = bl ? <span>{formatNumberZeroIfNull(bl, '0,0.[000]')}</span>
        : formatQuantity(row.purchaseProducts[0]);
    } else if ((row.sale || row.sale === 0) && row.saleProducts && row.saleProducts.length > 0) {
      if (row.saleProducts[0].saleLink) {
        bl = row.saleProducts[0].saleLink
          .reduce((sum, l) => sum + parseFloat(l.billLandingQuantity || 0), 0);
      }
      result = bl ? <span>{formatNumberZeroIfNull(bl, '0,0.[000]')}</span> :
        formatQuantity(row.saleProducts[0]);
    } else if ((row.transport || row.transport === 0) && row.transports) {
      let links = [];
      row.transports.forEach(t => {
        if (t.links) {
          links = links.concat(t.links);
        }
      });
      if (links && links.length > 0) {
        bl = links.reduce((sum, l) => sum + parseFloat(l.billLandingQuantity || 0), 0);
        if (bl) {
          result = <span>{formatNumberZeroIfNull(bl, '0,0.[000]')}</span>;
        }
      }
    }
    return (
      <div id={`quantity-${idx}`} className="payments-wrapped-text">
        {result}
      </div>);
  }

  handleAddPayment() {
    const timeAdded = new Date().getTime();
    this.props.addDealPayment(undefined, { operationOfficer: this.props.currentUser,
      dueAmountCurrency: Currency.DOLLAR, isDebit: true, timeAdded,
      dealtype: this.props.dealType }, true);
  }

  handleAddSubPayment(row, idx) {
    const parent = fromJS(row);
    if (parent) {
      const timeAdded = new Date().getTime();
      const payment = {
        parent: parent.get('id'),
        timeAdded,
        dealtype: this.props.dealType,
      };
      // добавление частичного платежа выполняется первый раз
      if (!this.isSubpayment() && !this.hasSubpayments(row)) {
        const newParent = {
          dueDate: undefined,
          bankRepaymentDate: undefined,
          paymentDate: undefined,
          totalDueCost: undefined,
          bankingCost: undefined,
          paymentAmount: undefined,
        };

        this.updateDealPayment(this.getPaymentIndex(row, idx), newParent);
      }
      this.props.addDealPayment(this.getPaymentIndex(row, idx), payment);
    }
  }

  handleAddSubPartial() {
    if (this.state.modalError) {
      return;
    }
    const paymentIdx = this.state.subPartialIdx;
    if (paymentIdx === undefined) {
      return;
    }
    const formData = (createFormData('payment-modal'));
    // if payment date is required and blank
    if ($('div .required input[name=paymentDate]').length
      && !formData.paymentDate && parseFloat(formData.paymentAmount)) {
      return;
    }
    if (!this.state.isNewPayment && this.state.row) {
      let paymentToUpdate = this.props.payments.get(paymentIdx);
      paymentToUpdate = paymentToUpdate
        .set('paymentAmount', formData.paymentAmount)
        .set('bankingCost', formData.bankingCost)
        .set('paymentDate', formData.paymentDate)
        .set('isCustomContractPayment',
          paymentToUpdate.get('isCustomContractPayment') ? false : undefined)
        .set('bank', formData.bank || formData.bank === 0 ?
          parseInt(formData.bank, 10) : formData.bank);
      this.updateDealPayment(paymentIdx, paymentToUpdate);
    } else {
      let parent = this.props.payments.get(paymentIdx);
      if (parent) {
        const payment = {
          ...formData,
          parent: parent.get('id'),
          isDetached: parent.get('isDetached', false),
          isSubPartial: true,
          approve: true,
          dealtype: this.props.dealType,
          isCustomContract: false,
        };
        // добавление частичного платежа выполняется первый раз
        if (!this.hasSubpaymentsByIdx(paymentIdx) && !paymentHasFinData(parent)) {
          parent = parent
            .set('paymentAmount', payment.paymentAmount)
            .set('bankingCost', payment.bankingCost)
            .set('paymentDate', payment.paymentDate)
            .set('bank', payment.bank || payment.bank === 0 ?
              parseInt(payment.bank, 10) : payment.bank);
          this.updateDealPayment(paymentIdx, parent);
        } else {
          const isNewSubpayment = this.state.row.outstanding > payment.paymentAmount;
          this.props.addDealPayment(paymentIdx, payment, isNewSubpayment);
        }
      }
    }
    this.closeModal();
  }

  handleRemovePayment(idx, id) {
    const currentExpenseIdx = this.props.expenses
      .findIndex(e => e.get('paymentExpense') &&
        e.get('expensesType') == this.props.payments.get(idx).get('expensesType')
        && (e.get('expensesTypeName') || '').toLowerCase() != FREIGHT_EXPENSES_TYPE
        && (e.get('expensesTypeName') || '').toLowerCase() != PRODUCT_EXPENSES_TYPE);
    if (this.props.payments.filter(p => p.get('expensesType') == this.props.payments.get(idx)
      .get('expensesType')).size == 1 && currentExpenseIdx > -1
        && this.props.payments.get('bulkPaymentTransports', new List()).size == 0) {
      this.props.expenses.forEach((e, eIdx) => {
        if (e.get('paymentExpense') && eIdx != currentExpenseIdx) {
          this.props.updatePaymentExpense(eIdx,
            formUnitedPaymentExpense(e, this.props.payments.delete(idx)));
        }
      });
      this.props.removePaymentExpense(currentExpenseIdx);
    } else {
      this.props.expenses.forEach((e, eIdx) => {
        if ((e.get('expensesTypeName') || '').toLowerCase() != INTEREST_EXPENSES_TYPE) {
          if (e.get('paymentExpense') &&
            this.props.payments.get('bulkPaymentTransports', new List()).size == 0) {
            this.props.updatePaymentExpense(eIdx,
              formUnitedPaymentExpense(e, this.props.payments.delete(idx)));
          }
        }
      });
    }
    this.props.removeDealPayment(idx, id);
  }

  handleSavePayment(payment) {
    if (payment) {
      this.props.tryToSaveDealPayment(payment);
    }
  }
  fillDynamicFields(paymentsArg, parent, props = this.props) {
    const payments = paymentsArg.get ? paymentsArg : fromJS(paymentsArg);
    return payments.map(p => {
      let tempP = this.isFinancialMode() || this.isTodaysReport() ? p :
        p.set('estimatedDueAmount', calcPercentContractPayment(p, props))
          .set('dueDate', calcContractDate(p, props));
      tempP = tempP.set('outstanding', calcOutstanding(tempP));
      const approveAvailableCheck = this.checkIfApprovedAvailable(tempP, parent, props);
      return tempP.set('approvedAvailable', approveAvailableCheck.available)
        .set('approveAlerts', approveAvailableCheck.alerts)
        .set('hasAnyApproved', this.checkIfApproved(tempP));
    }
    );
  }
  createTotalField(paymentsArg) {
    const payments = paymentsArg.get ? paymentsArg : fromJS(paymentsArg);
    let result = new Map();
    const sumAllPaymentAmount = (payment) => payment.get('payments', new List())
      .reduce((sum, p) => sum + p.get('paymentAmount', 0.00) + sumAllPaymentAmount(p), 0);


    const outstanding = dealOutstandingValue(payments);
    const paymentAmount = payments.reduce((sum, p) =>
      sum + (sumAllPaymentAmount(p) || 0) + (p.get('paymentAmount') || 0.00), 0);

    result = result.set('dueAmount',
      payments.reduce((sum, p) => sum + p.get('dueAmount', 0.00), 0) || 0)
      .set('outstanding', outstanding || 0)
      .set('paymentAmount', paymentAmount || 0);
    return result;
  }

  updateDealPayment(idx, mergeObject) {
    if (!mergeObject) {
      return;
    }
    let payment = this.props.payments.get(idx, new Map());
    payment = mergeObject.asImmutable ?
      payment.merge(mergeObject) : payment.merge(new Map(mergeObject));
    this.rebuildExpenses(idx, payment);
    this.props.updateDealPayment(idx, payment);
  }

  rebuildExpenses(index, payment, props = this.props, forceRebuild,
    restrictedExpenseIds = this.state.restrictedExpenseIds, overridenPayments) {
    if (this.isFinancialMode() || this.isTodaysReport()) {
      return;
    }
    const payments = overridenPayments || props.payments;
    const currentPayment = payments.get(index, new Map());
    const currentPaymentExpenseId = currentPayment.get('expensesType');
    const paymentExpenseId = payment.get('expensesType');
    const updatedPayments = payments.set(index, payment);
    // Если экспенс поменялся
    if (forceRebuild || currentPaymentExpenseId != paymentExpenseId) {
      let counter = 0;
      props.expenses.forEach((e) => {
        if ((payments.get('bulkPaymentTransports') || new List()).size == 0) {
          // старый экспенс
          if (e.get('expensesType') == currentPaymentExpenseId
            && (e.get('expensesTypeName') || '').toLowerCase() != FREIGHT_EXPENSES_TYPE
            && (e.get('expensesTypeName') || '').toLowerCase() != PRODUCT_EXPENSES_TYPE) {
            const newE = formUnitedPaymentExpense(e, updatedPayments, true);
            if (!newE.id && !newE.actual && !newE.estimate) {
              props.removePaymentExpense(counter);
              return;
            }
            if (e.get('expensesType') !== null && e.get('expensesType') !== undefined) {
              props.updatePaymentExpense(counter, newE);
            }
            // новый экспенс
          } else if (e.get('expensesType') !== null && e.get('expensesType') !== undefined &&
            e.get('expensesType') == paymentExpenseId
            && (e.get('expensesTypeName') || '').toLowerCase() != FREIGHT_EXPENSES_TYPE
            && (e.get('expensesTypeName') || '').toLowerCase() != PRODUCT_EXPENSES_TYPE) {
            props.updatePaymentExpense(counter, formUnitedPaymentExpense(e, updatedPayments));
          }
        }
        counter += 1;
      });
      if (payment.get('dueAmount') &&
        !(restrictedExpenseIds &&
          restrictedExpenseIds.includes(paymentExpenseId)) &&
        (payment.get('bulkPaymentTransports') || new List()).size == 0) {
        if (paymentExpenseId) {
          const existingExpenseIndex =
            props.expenses.findIndex((e) => e.get('expensesType') == paymentExpenseId);
          if (existingExpenseIndex == -1) {
            // создаем новый экспенс
            props.addPaymentExpense(this.formPaymentExpense(payment));
          }
        }
      }
    } else {
      if (paymentExpenseId &&
        !(restrictedExpenseIds &&
          restrictedExpenseIds.includes(paymentExpenseId))
          && (payment.get('bulkPaymentTransports') || new List()).size == 0
      ) {
        const existingExpenseIndex =
          props.expenses.findIndex(e => e.get('expensesType') == paymentExpenseId);
        if (existingExpenseIndex > -1) {
          const existingExpense = props.expenses.get(existingExpenseIndex);
          // обновляем экспенс на основе пеймента
          if (!restrictedExpenseIds.includes(existingExpense.get('expensesType'))) {
            props.updatePaymentExpense(existingExpenseIndex,
              formUnitedPaymentExpense(existingExpense, updatedPayments));
          }
        } else if (payment.get('dueAmount')) {
          // создаем новый экспенс
          props.addPaymentExpense(this.formPaymentExpense(payment));
        }
      }
    }
    props.setExpensesRebuilded();
  }

  createTotalRow(filtered = new List(), currency = Currency.DOLLAR, totalRowName) {
    let totalRow = new Map();
    totalRow = this.createTotalField(filtered);
    totalRow = totalRow.set(totalRowName, true)
      .set('dueAmountCurrency', currency);
    return totalRow;
  }

  addBankingCostToTotalRow(filtered = new List(), totalRow = new Map(),
    totalOutstanding, allPayments) {
    if (filtered.size > 0) {
      if (!totalOutstanding) {
        const bankingCost = filtered.reduce((sum, p) =>
          sum + sumAllBankingCost(p) + p.get('bankingCost', 0.00), 0);
        return allPayments.push(totalRow
          .set('bankingCost', bankingCost));
      }
      return allPayments.push(totalRow);
    }
    return allPayments;
  }

  addTotalRowsWithCurrency(allPayments = new List(), filterFunc, isDebit) {
    const filteredPayments = allPayments
      .filter(p => !p.get('isTotalDebitRow') && !p.get('isTotalCreditRow'));
    const usdPayments = filteredPayments
      .filter(p => p.get('dueAmountCurrency') == Currency.DOLLAR || !p.get('dueAmountCurrency'));
    let currencyGrouppedPayments = filteredPayments.groupBy(p => p.get('dueAmountCurrency'))
      .filter((v, k) => k !== Currency.DOLLAR);
    const totalRowName = isDebit ? 'isTotalDebitRow' : 'isTotalCreditRow';

    const filteredUSD = usdPayments.filter(filterFunc);
    currencyGrouppedPayments = currencyGrouppedPayments.map(group => group.filter(filterFunc));

    if (!filteredUSD.size && !currencyGrouppedPayments.filter(group => group.size).size) {
      return allPayments.push(
        new Map().set(totalRowName, true).set('dueAmountCurrency', Currency.DOLLAR)
          .set('outstanding', 0)
          .set('paymentAmount', 0)
          .set('dueAmount', 0)
      );
    }
    const totalUSDRow = filteredUSD.size > 0 ?
      this.createTotalRow(filteredUSD, Currency.DOLLAR, totalRowName) : new Map();

    let currenciesTotalRows = currencyGrouppedPayments.map((group, currency) =>
      (group.size ? this.createTotalRow(group, currency, totalRowName) : new Map()));

    currenciesTotalRows = currenciesTotalRows.map((group, currency) =>
      (currencyGrouppedPayments.get(currency).size
        ? group.set('hideTotalTitle', !!filteredUSD.size) : group));

    const totalOutstanding = totalUSDRow.get('outstanding', 0.00)
      + currenciesTotalRows.reduce((total, group) =>
        total + group.get('outstanding', 0.00), 0.00);
    let newAllPayments = allPayments;
    newAllPayments = this.addBankingCostToTotalRow(filteredUSD, totalUSDRow,
      totalOutstanding, newAllPayments);

    currenciesTotalRows.forEach((group, currency) => {
      newAllPayments = this.addBankingCostToTotalRow(currencyGrouppedPayments.get(currency), group,
        totalOutstanding, newAllPayments);
    });
    return newAllPayments;
  }

  openModalDelete(paymentIdx, paymentId) {
    this.setState({ showModalDelete: true, paymentIdx, paymentId });
  }

  closeModalDelete() {
    this.setState({ showModalDelete: false, paymentIdx: null, paymentId: null });
  }

  yesButtonDelete() {
    this.handleRemovePayment(this.state.paymentIdx, this.state.paymentId);
    this.closeModalDelete();
  }

  canEditTopApprove() {
    return !this.isFinancialMode();
  }

  topApproveFormatter(value, row, formatExtraData, idx) {
    if (this.isTotalRow(row) || !row.approve) {
      return '';
    }
    const approveState = row.topManagerApproveState || 0;
    let buttonStyle = null;
    let disabled = false;
    const rootDisabled = !this.canEditTopApprove();
    let node = <Glyphicon glyph="send" />;
    let tooltip = null;

    let expiredId = null;
    let declinedId = null;
    switch (approveState) {
      case 'PENDING': {
        buttonStyle = 'info';
        disabled = true;
        node = 'AP';
        const topApprover = this.props.topmanagers.find(tm => tm.get('id') == row.topApprover,
          this, new Map());
        tooltip = `Approve pending by ${topApprover.get('name')}`;
        const expireTime = row.topApproverLinkExpireTime;
        const date = new Date();
        if (expireTime && moment(expireTime).toDate().getTime() <
          (date.getTime() + new Date().getTimezoneOffset() * 60000)) {
          buttonStyle = 'warning';
          disabled = rootDisabled;
          node = 'EXP';
          tooltip = `Approve by ${topApprover.get('name')} has expired`;
          expiredId = row.topApprover;
        }
      } break;
      case 'APPROVED': {
        buttonStyle = 'primary';
        disabled = true;
        node = <Glyphicon glyph="thumbs-up" />;

        const topApprover = this.props.topmanagers.find(tm => tm.get('id') == row.topApprover,
          this, new Map());
        tooltip = `Approved successfully by ${topApprover.get('name')}`;
      } break;
      case 'DECLINED': {
        buttonStyle = 'danger';
        disabled = false;
        node = <Glyphicon glyph="thumbs-down" />;

        const topApprover = this.props.topmanagers.find(tm => tm.get('id') == row.topApprover,
          this, new Map());
        tooltip = `Declined by ${topApprover.get('name')}\nComment: ${row.approveComment}`;
        declinedId = row.topApprover;
      } break;
      default: {
        if (rootDisabled) {
          return '';
        }
        buttonStyle = 'link';
        tooltip = 'Top manager not assigned for approve';
      }
    }
    if (!row.outstanding) {
      disabled = true;
    }
    return (
      <CustomCell
        value={`${disabled}_${tooltip}`}
        data={<div id={`approve-${idx}-${this.isDirty(idx)}`}>
          <input
            type="checkbox"
            checked={value}
            style={{ display: 'none' }}
          />
          {!this.hasSubpayments(idx, true) && !row.isSubPartial
            ?
            <div title={tooltip} style={{ display: 'inline-block', cursor: 'not-allowed' }}>
              <Button
                disabled={disabled}
                bsStyle={buttonStyle}
                style={{ width: 30, height: 30, padding: 0,
                  pointerEvents: disabled ? 'none' : 'all' }}
                onClick={() => {
                  this.setState({ showTopManagerModal: true,
                    topManagerIdx: this.getPaymentIndex(row, idx),
                    expiredId,
                    declinedId,
                  });
                }}
              >
                {node}
              </Button>
            </div>

            : ''
          }
        </div>}
      />
    );
  }

  finTopApproveFormatter(value, row, formatExtraData, idx) {
    const approveState = row.topManagerApproveState || 0;
    if (this.isTotalRow(row) || !row.approve) {
      return '';
    }
    let buttonStyle = null;
    let node;
    let tooltip = null;

    switch (approveState) {
      case 'PENDING': {
        buttonStyle = 'info';
        node = 'AP';
        const topApprover = this.props.topmanagers.find(tm => tm.get('id') == row.topApprover,
          this, new Map());
        tooltip = `Approve pending by ${topApprover.get('name')}`;
        const expireTime = row.topApproverLinkExpireTime;
        const date = new Date();
        if (expireTime && moment(expireTime).toDate().getTime() <
          (date.getTime() + new Date().getTimezoneOffset() * 60000)) {
          buttonStyle = 'warning';
          node = 'EXP';
          tooltip = `Approve by ${topApprover.get('name')} has expired`;
        }
      } break;
      case 'APPROVED': {
        buttonStyle = 'primary';
        node = <Glyphicon glyph="thumbs-up" />;
        const topApprover = this.props.topmanagers.find(tm => tm.get('id') == row.topApprover,
          this, new Map());
        tooltip = `Approved successfully by ${topApprover.get('name')}`;
      } break;
      case 'DECLINED': {
        buttonStyle = 'danger';
        node = <Glyphicon glyph="thumbs-down" />;

        const topApprover = this.props.topmanagers.find(tm => tm.get('id') == row.topApprover,
          this, new Map());
        tooltip = `Declined by ${topApprover.get('name')}\nComment: ${row.approveComment}`;
      } break;
      default: break;
    }
    return (
      node ?
        <CustomCell
          value={row.topManagerApproveState}
          data={
            <div id={`approve-${idx}-${this.isDirty(idx)}`}>
              {!this.hasSubpayments(idx, true) && !row.isSubPartial
                ?
                <div title={tooltip} style={{ display: 'inline-block', cursor: 'not-allowed' }}>
                  <Button
                    disabled
                    bsStyle={buttonStyle}
                    style={{ width: 30, height: 30, padding: 0,
                      pointerEvents: 'none' }}
                  >
                    {node}
                  </Button>
                </div>
                : ''
              }
            </div>}
        /> : '');
  }

  closeTopManagerModal() {
    this.setState({ showTopManagerModal: false, topManagerIdx: null, expiredId: null });
  }

  closeBulkPaymentModal() {
    this.setState({ showBulkPaymentModal: false, idxForBulkPayment: undefined,
      selectedBulkTransports: undefined, bulkType: undefined });
  }

  filterData(data, props = this.props) {
    if (this.isFinancialMode() && !this.isSubpayment()) {
      const filterIds = props.filterIds.toJS();
      const newData = data.filter((d) => {
        if ((!props.hideArchivedDetachedPayments && d.get('isDetached'))
          || filterIds.includes(d.get('id'))) {
          if (props.isClosed) {
            return true;
          }
          if (props.showDebit && d.get('isDebit')) {
            return true;
          } else if (props.showCredit && !d.get('isDebit')) {
            return true;
          }
        }
        return false;
      });
      return newData;
    }
    return data;
  }

  permissionFilter(data, props = this.props) {
    if (this.isFinancialMode() && !this.isSubpayment()) {
      if (validateRoleConfig(['financesViewEditDelete', 'viewPayments'])) {
        return data;
      }
      let result = new List();
      if (validateRoleConfig(['myPaymentsView'])) {
        data.forEach((d) => {
          if (isUserPayment(d, props.currentUser, props.purchases, props.sales, props.transports)) {
            result = result.push(d);
          }
        });
      }
      return result;
    }
    return data;
  }

  renderAdditionalElements() {
    return (<DetachedPayment
      value={this.props.payments.get(this.state.paymentIdx)}
      show={this.state.showModalEditAttrs}
      onClose={this.closeModalEditAttrs}
      parent={this.state.modalEditAttrsParent}
    />);
  }

  fillTodaysReportsLinks(links = new List(), dealList = new List(),
    dealIdField, dealProductField, dealsSet = new Set(), productsSet = new Set()) {
    let dealsResult = dealsSet;
    let productsResult = productsSet;
    links.forEach(l => {
      if (l.get(dealIdField) || l.get(dealIdField) === 0) {
        const deal = dealList.find(p => p.get('id') == l.get(dealIdField));
        if (deal) {
          dealsResult = dealsResult.add(deal);
          if (dealProductField) {
            const product = deal.get('products', new List())
              .find(pr => pr.get('id') == l.get(dealProductField));
            if (product) {
              productsResult = productsResult.add(product);
            }
          }
        }
      }
    });
    return { dealsResult, productsResult };
  }
  fillTodaysReportsDeals(paymentsList, props) {
    if (!paymentsList) {
      return paymentsList;
    }
    return paymentsList.map(data => {
      if (data.get('isDetached')) {
        return data;
      }
      let purchases = new Set();
      let purchaseProducts = new Set();
      let sales = new Set();
      let saleProducts = new Set();
      let transports = new Set();
      if (data.get('transport') || data.get('transport') === 0 || props.dealType == 'transport') {
        const transport = props.dealType == 'transport' ? props.currentDeal :
          props.transports.find(t => t.get('id') == data.get('transport'));

        if (transport) {
          transports = transports.add(transport);
          const links = transport.get('links', new List());
          const resultPurchase = this.fillTodaysReportsLinks(links, props.purchases, 'purchaseId',
            'purchaseProduct', purchases, purchaseProducts);
          purchases = purchases.union(resultPurchase.dealsResult);
          purchaseProducts = purchaseProducts.union(resultPurchase.productsResult);

          const resultSale = this.fillTodaysReportsLinks(links, props.sales, 'saleId',
            'saleProduct', sales, saleProducts);
          sales = sales.union(resultSale.dealsResult);
          saleProducts = saleProducts.union(resultSale.productsResult);
        }
      } else if (data.get('purchase') || data.get('purchase') === 0
       || props.dealType == 'purchase') {
        const purchase = props.dealType == 'purchase' ? props.currentDeal :
          props.purchases.find(t => t.get('id') == data.get('purchase'));
        if (purchase) {
          purchases = purchases.add(purchase);
          if (data.get('compositeProduct') || data.get('compositeProduct') === 0) {
            const product = purchase.get('products', new List())
              .find(p => p.get('id') == data.get('compositeProduct'));
            if (product) {
              purchaseProducts = purchaseProducts.add(product);
              const links = product.get('purchaseLink');

              const resultSale = this.fillTodaysReportsLinks(links,
                props.sales, 'saleId', 'saleProduct', sales, saleProducts);
              sales = sales.union(resultSale.dealsResult);
              saleProducts = saleProducts.union(resultSale.productsResult);

              const resultTransport = this.fillTodaysReportsLinks(links,
                props.transports, 'transport', transports);
              transports = transports.union(resultTransport.dealsResult);
            }
          }
        }
      } else if (data.get('sale') || data.get('sale') === 0 || props.dealType == 'sale') {
        const sale = props.dealType == 'sale' ? props.currentDeal :
          props.sales.find(t => t.get('id') == data.get('sale'));
        if (sale) {
          sales = sales.add(sale);
          if (data.get('compositeProduct') || data.get('compositeProduct') === 0) {
            const product = sale.get('products', new List())
              .find(p => p.get('id') == data.get('compositeProduct'));
            if (product) {
              saleProducts = saleProducts.add(product);
              const links = product.get('saleLink');

              const resultPurchase = this.fillTodaysReportsLinks(links,
                props.purchases, 'purchaseId', 'purchaseProduct', purchases, purchaseProducts);
              purchases = purchases.union(resultPurchase.dealsResult);
              purchaseProducts = purchaseProducts.union(resultPurchase.productsResult);

              const resultTransport = this.fillTodaysReportsLinks(links,
                props.transports, 'transport', transports);
              transports = transports.union(resultTransport.dealsResult);
            }
          }
        }
      }
      return data.set('purchases', purchases).set('purchaseProducts', purchaseProducts)
        .set('sales', sales)
        .set('saleProducts', saleProducts)
        .set('transports', transports);
    });
  }

  canSortDRCR() {
    return false;
  }

  hideContractField() {
    return false;
  }
  hideVesselNameField() {
    return false;
  }

  tableClassName() {
    // eslint-disable-next-line
    return `${this.isSubpartialTable() ? 'sub-partial-table' :
      this.isSubpayment() ? 'sub-payment-table ' : 'payments '}`;
  }

  sortDueDateInitial(a, b, order) {
    if (!this.initialSortSet) {
      $('#paymentContainer').ready(() => onSortChange('resolvedDueDate'));
      this.initialSortSet = true;
    }
    return sortDueDate(a, b, order);
  }

  recalculateCustomContractPayment(props, payments) {
    if (!this.isFinancialMode() && props.product) {
      const totalBl = this.props.products.reduce((total, product) =>
        total + product.get(`${props.dealType}Link`)
          .reduce((total2, link) => total2 + link.get('billLandingQuantity', 0), 0), 0);
      const newTotalBl = props.products.reduce((total, product) =>
        total + product.get(`${props.dealType}Link`)
          .reduce((total2, link) => total2 + link.get('billLandingQuantity', 0), 0), 0);
      const productExpensesTypeId = this.props.expensestypes.find(elem => elem.get('name', '')
        .toLowerCase() == PRODUCT_EXPENSES_TYPE).get('id');
      const contractPaymentsCount = this.state.nonSubPartialPayments
        .filter(p => p.expensesType == productExpensesTypeId);
      const contractPaymentsTotal = contractPaymentsCount
        .filter(p => p.expensesType == productExpensesTypeId)
        .reduce((total, payment) => total + (payment.dueAmount || 0), 0);
      const newContractPaymentsCount = payments.filter(p =>
        p.get('expensesType') == productExpensesTypeId);
      const newContractPaymentsTotal = newContractPaymentsCount
        .reduce((total, payment) => total + payment.get('dueAmount', 0), 0);

      if (contractPaymentsCount != newContractPaymentsCount || totalBl != newTotalBl
        || contractPaymentsTotal != newContractPaymentsTotal
        || props.product.get('priceValue') != this.props.product.get('priceValue')
        || props.product.get('priceCurrency') != this.props.product.get('priceCurrency')) {
        const fullCost = props.product.get('priceValue', 0) * newTotalBl;
        return payments.map((row, idx) => {
          let updated = row;
          if (updated.get('isCustomContractPayment') && !updated.get('approve')) {
            if (updated.get('fullCostType') == 'PERCENT') {
              updated = updated.set('dueAmount', fullCost *
                (updated.get('fullCostPercent') || 0) / 100);
              updated = updated.set('dueAmountCurrency', props.product.get('priceCurrency'));
            } else if (updated.get('fullCostType') == 'BALANCE') {
              const allContractPaymentsSum = payments.filter((p, pIdx) => {
                const expensesType =
                  props.expensestypes.find(elem => elem.get('id') == p.get('expensesType'));
                return idx != pIdx && expensesType &&
                  expensesType.get('name', '').toLowerCase() == PRODUCT_EXPENSES_TYPE;
              })
                .reduce((total, p) => total + p.get('dueAmount', 0), 0);
              updated = updated.set('dueAmount', fullCost - allContractPaymentsSum);
              updated = updated.set('dueAmountCurrency', props.product.get('priceCurrency'));
            }
          }
          return updated;
        });
      }
    }
    return payments;
  }

  prepareData(props = this.props, fillReport = true) {
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return {};
    }
    let payments =
      this.permissionFilter(this.filterData(props.payments
        ? props.payments
        : new List(), props));
    if (!this.isFinancialMode() || this.isSubpayment()) {
      payments = payments.map((p, idx) => p.set('paymentIdx', idx));
    }
    // payments = this.recalculateCustomContractPayment(props, payments);
    const subPartialPayments = payments.filter(payment => payment.get('isSubPartial'))
      .map((p, idx) => p.set('idx', idx)).toJS();
    let nonSubPartialPayments = payments.map((p, idx) =>
      p.set('paymentKey', p.get('id') || p.get('timeAdded', idx)).set('idx', idx)
        .set('originalPayment', p));
    // nonSubPartialPayments = nonSubPartialPayments.toJS();
    // return { nonSubPartialPayments, subPartialPayments };
    const parent = props.parentPayments && props.paymentIdx !== undefined ?
      props.parentPayments.get(props.paymentIdx) : undefined;
    nonSubPartialPayments = this.fillDynamicFields(nonSubPartialPayments, parent, props);
    if (!this.isSubpayment() && !this.isFinancialMode() && !this.isTodaysReport()) {
      nonSubPartialPayments = this.addTotalRowsWithCurrency(nonSubPartialPayments,
        (p) => p.get('isDebit'), true);
      nonSubPartialPayments = this.addTotalRowsWithCurrency(nonSubPartialPayments,
        (p) => !p.get('isDebit'), false);
      nonSubPartialPayments = nonSubPartialPayments
        .map(p => p.set('dueAmountValid', this.validateDueAmount(p)));
    }
    nonSubPartialPayments = this.fillTodaysReportsDeals(nonSubPartialPayments, props);
    if (!this.isSubpayment() && this.isFinancialMode() && !this.props.isCommonPayments) {
      if (!props.isClosed) {
        nonSubPartialPayments = nonSubPartialPayments.filter(e =>
          (e.get('outstanding') && e.get('outstanding') >= 1) || !e.get('dueAmount'));
      } else {
        nonSubPartialPayments = nonSubPartialPayments.filter(e =>
          (!e.get('outstanding') || e.get('outstanding') < 1) && e.get('dueAmount'));
      }
    }
    nonSubPartialPayments = nonSubPartialPayments.toJS();
    nonSubPartialPayments = nonSubPartialPayments.map(e => {
      if (!fillReport) {
        const oldE = this.state.nonSubPartialPayments.find(stateE => stateE.id == e.id);
        if (oldE) {
          let isEqual = true;
          Object.keys(e).forEach((prop) => {
            if (isEqual) {
              if (!e.hasOwnProperty(prop)) {
                isEqual = false;
              } else if (typeof e[prop] == 'object') {
                if (JSON.stringify(e[prop]) != JSON.stringify(oldE[prop])) {
                  isEqual = false;
                }
              } else if (e[prop] != oldE[prop]) {
                isEqual = false;
              }
            }
          });
          if (isEqual) {
            return oldE;
          }
        }
      }
      const newE = { ...e };
      const currency = newE.parent || newE.parent === 0 ?
        formatCurrency(props.parentPayments.find(p => p.get('id') == newE.parent, this, new Map())
          .get('dueAmountCurrency'))
        :
        formatCurrency(newE.dueAmountCurrency);
      newE.resolvedPaymentAmount =
          `${currency} ${formatNumberZeroIfNull(newE.paymentAmount || 0, '0,0.00') || '0.00'}`;
      newE.resolvedContractNumberTitle = this.resolveContractNumberTitle(newE);
      if (!this.isTodaysReport()) {
        newE.linkedVesselName = this.resolveVesselName(newE, props);
        newE.resolvedOutstanding = !newE.dueAmount ? '' :
          `${currency} ${formatNumberZeroIfNull(newE.outstanding || 0, '0,0.00') || '0.00'}`;
        newE.resolvedBankingCost =
          `${currency} ${formatNumberZeroIfNull(newE.bankingCost || 0, '0,0.00') || '0.00'}`;
        newE.resolvedPaymentDate = newE.paymentDate || '';
        if (this.isFinancialMode()) {
          newE.resolvedUserFullname = props.users.find(ref => ref.get('id') ==
          newE.operationOfficer, this, new Map()).get('fullname', '');
          newE.resolvedUser = newE.resolvedUserFullname ? newE.resolvedUserFullname
            .split(' ')
            .map((n, i) => (i == 0 ? `${n[0]}.` : `${n.slice(0, 2)}.`))
            .join(' ') : '';
          newE.resolvedType = props.expensestypes
            .find(ref => ref.get('id') == newE.expensesType, this, new Map()).get('name', '');
          newE.resolvedPaymentMethod = props.paymentMethods
            .find(ref => ref.get('id') == newE.paymentMethod, this, new Map()).get('name', '');
          newE.resolvedDocType = props.docTypes
            .find(ref => ref.get('id') == newE.documentType, this, new Map()).get('name', '');
          newE.resolvedBank = props.banks
            .find(ref => ref.get('id') == newE.bank, this, new Map()).get('name', '');
          newE.resolvedDueAmount = newE.dueAmount ?
            `${currency} ${formatNumberZeroIfNull(newE.dueAmount)}` : '';
          newE.resolvedEstimatedDueAmount = newE.estimatedDueAmount ?
            `${currency} ${formatNumberZeroIfNull(newE.estimatedDueAmount)}` : '';
          newE.resolvedDueDate = newE.dueDate || '';
          newE.resolvedBankRepaymentDate = newE.bankRepaymentDate || '';
          newE.resolvedEstimatedDueDate = newE.estimatedDueDate || '';
        }
      }
      return newE;
    });
    return { nonSubPartialPayments, subPartialPayments };
  }

  getPaginationOptions(props = this.props) {
    return {
      page: props.currentPage,
      sizePerPage: props.pageSize,
      sizePerPageList: props.pageSizeOptions,
      onPageChange: props.onPageChange,
      paginationPanel: props.paginationPanel };
  }

  getTable() {
    return this.isFinancialMode() ? this.getFinTable() : this.getNotFinTable();
  }

  getFinTable() {
    const options = { ...this.finOptions, ...this.getPaginationOptions() };
    return (<BootstrapTable
      headerStyle={this.isSubpayment() ? { display: 'none' } : {}}
      hover
      className={this.tableClassName()}
      trClassName={this.validationClassname}
      data={this.state.nonSubPartialPayments}
      options={options}
      expandableRow={this.isExpandableRow}
      expandComponent={this.expandComponent}
      tableHeaderClass="payments-headers"
      pagination={!this.props.subpayment}
      ref="table"
      keyField="paymentKey"
      id="paymentsTable"
      bordered={false}
      search={!this.props.subpayment}
    >
      <TableHeaderColumn
        expandable={false}
        dataSort={!this.props.subpayment}
        sortFunc={sortPay}
        width="50px"
        dataField="approve"
        dataAlign="center" headerAlign="center"
        dataFormat={this.finApproveFormatter}
        searchable={false}
      >
        Pay
      </TableHeaderColumn>
      <TableHeaderColumn
        dataSort={!this.props.subpayment}
        sortFunc={sortId}
        dataField="id"
        hidden
        searchable={false}
      />
      <TableHeaderColumn
        expandable={false}
        width="40px"
        dataField="topApprove"
        dataAlign="center" headerAlign="center"
        dataFormat={this.finTopApproveFormatter}
        searchable={false}
      >
        TA
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="40px"
        dataSort={this.canSortDRCR() && !this.props.subpayment}
        sortFunc={sortDRCR}
        dataField="isDebit"
        formatExtraData="isDebit"
        dataAlign="center" headerAlign="center"
        dataFormat={this.finDebitCreditFormatter}
        searchable={false}
      >
        DR/CR
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="45px"
        dataField="resolvedUser"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.finUserNameFormatter}
      >
       Ops
      </TableHeaderColumn>

      {this.state.viewMode != BRIEF_MODE && <TableHeaderColumn
        expandable={false}
        width="80px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleTextFunc('resolvedContractNumberTitle')}
        dataField="resolvedContractNumberTitle"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.contractNumberFormatter}
      >
        Contract #
      </TableHeaderColumn>
      }
      {this.state.viewMode != BRIEF_MODE && <TableHeaderColumn
        expandable={false}
        width="90px"
        dataSort={!this.props.subpayment}
        sortFunc={sortDocumentNumber}
        dataField="documentNumber"
        formatExtraData="documentNumber"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Document #
      </TableHeaderColumn>
      }
      {this.state.viewMode != BRIEF_MODE && <TableHeaderColumn
        expandable={false}
        width="140px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleTextFunc('resolvedDocType')}
        dataField="resolvedDocType"
        formatExtraData="resolvedDocType"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        hidden={this.state.viewMode == BRIEF_MODE}
        dataFormat={this.simpleTextFormatter}
      >
        Document type
      </TableHeaderColumn>
      }
      <TableHeaderColumn
        expandable={false}
        width="140px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleTextFunc('resolvedType')}
        dataField="resolvedType"
        formatExtraData="resolvedType"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.finTypeFormatter}
      >
        Type
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="100px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleTextFunc('resolvedPaymentMethod')}
        dataField="resolvedPaymentMethod"
        formatExtraData="resolvedPaymentMethod"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Payment method
      </TableHeaderColumn>
      {!this.hideVesselNameField() && <TableHeaderColumn
        expandable={false}
        width="140px"
        dataAlign="right" headerAlign="right"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleTextFunc('linkedVesselName')}
        formatExtraData="linkedVesselName"
        dataField="linkedVesselName"
        columnClassName="payments-wrapped-text-td"
        hidden={this.hideVesselNameField()}
        dataFormat={this.vesselNameTextFormatter}
      >
        Vessel Name
      </TableHeaderColumn>
      }
      <TableHeaderColumn
        expandable={false}
        width="100px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleTextFunc('counterpartyName')}
        dataField="counterpartyName"
        formatExtraData="counterpartyName"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Counterparty
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="100px"
        dataSort={!this.props.subpayment}
        sortFunc={sortSimpleTextFunc('counterpartyLegalName')}
        dataField="counterpartyLegalName"
        formatExtraData="counterpartyLegalName"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Legal Name
      </TableHeaderColumn>
      {hasUserAnyRole(['ROLE_FINANCE']) &&
        <TableHeaderColumn
          search
          expandable={false}
          width="160px"
          dataField="bank"
          dataSort={!this.props.subpayment}
          sortFunc={sortSimpleTextFunc('resolvedBank')}
          dataField="resolvedBank"
          formatExtraData="resolvedBank"
          columnClassName="payments-wrapped-text-td"
          dataAlign="right" headerAlign="right"
          dataFormat={this.simpleTextFormatter}
        >
          Bank
        </TableHeaderColumn>
      }
      <TableHeaderColumn
        expandable={false}
        width="114px"
        dataField="resolvedBankRepaymentDate"
        dataSort={!this.props.subpayment}
        sortFunc={sortBankRepaymentDate}
        formatExtraData="resolvedBankRepaymentDate"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Bank Repayment Date
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="130px"
        dataSort={!this.props.subpayment}
        sortFunc={sortDueAmount}
        dataField="resolvedDueAmount"
        formatExtraData="resolvedDueAmount"
        columnClassName="payments-money payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatterWithCurrency}
        dataAlign="right" headerAlign="right"
      >
        Due Amount
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="114px"
        dataField="resolvedDueDate"
        dataSort={!this.props.subpayment}
        sortFunc={this.props.subpayment ? () => {} : this.sortDueDateInitial}
        formatExtraData="resolvedDueDate"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Due Date
      </TableHeaderColumn>

      <TableHeaderColumn
        expandable={false}
        width="120px"
        dataSort={!this.props.subpayment}
        sortFunc={sortPaymentAmount}
        dataField="resolvedPaymentAmount"
        formatExtraData="resolvedPaymentAmount"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatterWithCurrency}
      >
        Payment Amount
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="114px"
        dataField="resolvedPaymentDate"
        dataSort={!this.props.subpayment}
        sortFunc={sortPaymentDate}
        formatExtraData="resolvedPaymentDate"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Payment Date
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="100px"
        dataSort={!this.props.subpayment}
        sortFunc={sortOutstanding}
        dataField="resolvedOutstanding"
        formatExtraData="resolvedOutstanding"
        dataAlign="right" headerAlign="right"
        dataFormat={this.simpleTextFormatterWithCurrency}
        columnClassName={'payments-wrapped-text-td payments-money payments-outstanding'}
      >
        Outstanding
      </TableHeaderColumn>

      {this.state.viewMode != BRIEF_MODE && <TableHeaderColumn
        expandable={false}
        width="100px"
        dataSort={!this.props.subpayment}
        sortFunc={sortBankingCost}
        dataField="resolvedBankingCost"
        formatExtraData="resolvedBankingCost"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatterWithCurrency}
      >
        Banking Cost
      </TableHeaderColumn>
      }
      {(this.state.viewMode != BRIEF_MODE
        && !hasUserAnyRole(['ROLE_FINANCE'])) &&
        <TableHeaderColumn
          expandable={false}
          width="160px"
          dataField="bank"
          dataSort={!this.props.subpayment}
          sortFunc={sortSimpleTextFunc('resolvedBank')}
          dataField="resolvedBank"
          formatExtraData="resolvedBank"
          columnClassName="payments-wrapped-text-td"
          dataAlign="right" headerAlign="right"
          dataFormat={this.simpleTextFormatter}
        >
          Bank
        </TableHeaderColumn>
      }
      {this.state.viewMode != BRIEF_MODE && <TableHeaderColumn
        expandable={false}
        width="160px"
        dataField="notes"
        formatExtraData="notes"
        dataAlign="right" headerAlign="right"
        dataFormat={this.textMultiFormatter}
      >
        Notes
      </TableHeaderColumn>
      }
      <TableHeaderColumn
        expandable={false}
        width="60px"
        dataField="document"
        formatExtraData="document"
        dataAlign="center" headerAlign="right"
        dataFormat={this.invoiceFormatter}
        searchable={false}
        columnClassName={'payments-pre-last-columns'}
        className={'payments-pre-last-columns-header'}
      />
      <TableHeaderColumn
        expandable={false}
        width="45px"
        dataField="idx"
        dataAlign="center" headerAlign="left"
        dataFormat={this.deleteButton}
        searchable={false}
        className={'payments-last-columns-header'}
        columnClassName={'payments-last-columns'}
      >
        <Button
          bsStyle="primary"
          className={'payments-expand-button'}
          onClick={this.changeViewMode}
        >
          {this.state.viewMode == BRIEF_MODE ? <ResizeExpand /> : <ResizeCollapse />}
        </Button>
      </TableHeaderColumn>
      <TableHeaderColumn
        expandable={false}
        width="45px"
        dataField="id"
        dataAlign="center" headerAlign="left"
        dataFormat={this.editSubPartialPaymentFormatter}
        searchable={false}
        className={'payments-last-columns-header'}
        columnClassName={'payments-last-columns'}
      />
      {!this.props.isClosed &&
        <TableHeaderColumn
          expandable={false}
          width="100px"
          dataField="id"
          dataAlign="center" headerAlign="left"
          dataFormat={this.addSubPartialPaymentFormatter}
          searchable={false}
          className={'payments-last-columns-header'}
          columnClassName={'payments-last-columns payments-pay-column'}
        />
      }
    </BootstrapTable>);
  }

  getNotFinTable() {
    const options = { ...this.baseOptions, ...this.getPaginationOptions() };
    return (<BootstrapTable
      hover
      headerStyle={this.isSubpayment() ? { display: 'none' } : {}}
      bordered={false}
      // eslint-disable-next-line
      className={this.tableClassName()}
      trClassName={this.validationClassname}
      data={this.state.nonSubPartialPayments}
      options={options}
      expandableRow={this.isExpandableRow}
      expandComponent={this.expandComponent}
      tableHeaderClass="payments-headers"
      ref="table"
      keyField="paymentKey"
      id="paymentsTable"
    >

      {!this.isTodaysReport() &&
        <TableHeaderColumn
          expandable={false}
          sortFunc={sortPay}
          width="40px"
          dataField="approve"
          dataAlign="center" headerAlign="right"
          dataFormat={this.approveFormatter}
        >
          Pay
        </TableHeaderColumn>
      }
      {!this.isTodaysReport() &&
        <TableHeaderColumn
          expandable={false}
          width="40px"
          dataField="topApprove"
          dataAlign="center" headerAlign="right"
          dataFormat={this.topApproveFormatter}
        >
          TA
        </TableHeaderColumn>
      }
      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="40px"
        dataField="isDebit"
        formatExtraData="isDebit"
        dataAlign="center" headerAlign="right"
        dataFormat={this.debitCreditFormatter}
      >
        DR/CR
      </TableHeaderColumn>
      }
      {!(this.hideContractField() || this.props.dealType == 'transport'
      || this.isTodaysReport() || this.state.viewMode == BRIEF_MODE) && <TableHeaderColumn
        expandable={false}
        width="80px"
        dataField="contractNumber"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.contractNumberFormatter}
      >
        Contract #
      </TableHeaderColumn>
      }
      {!(this.isTodaysReport() || this.state.viewMode == BRIEF_MODE) && <TableHeaderColumn
        expandable={false}
        width="90px"
        dataField="documentNumber"
        formatExtraData="documentNumber"
        dataAlign="right" headerAlign="right"
        dataFormat={this.isSubpayment() ? undefined : this.textFormatter}
      >
        Document #
      </TableHeaderColumn>
      }
      {!(this.isTodaysReport() || this.state.viewMode == BRIEF_MODE) && <TableHeaderColumn
        expandable={false}
        width="140px"
        dataField="documentType"
        formatExtraData="documentType"
        dataAlign="right" headerAlign="right"
        dataFormat={this.documentTypeFormatter}
      >
        Document type
      </TableHeaderColumn>
      }
      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="140px"
        dataField="expensesType"
        formatExtraData="expensesType"
        dataAlign="right" headerAlign="right"
        dataFormat={this.expensesTypeFormatter}
      >
        Type
      </TableHeaderColumn>
      }
      {!this.isTodaysReport() && this.props.dealType != 'transport' && <TableHeaderColumn
        expandable={false}
        width="100px"
        dataField="paymentMethod"
        columnClassName={this.isTodaysReport() ? 'payments-wrapped-text-td' : ''}
        dataAlign="right" headerAlign="right"
        dataFormat={this.paymentMethodFormatter}
      >
        Payment method
      </TableHeaderColumn>
      }
      {!(this.hideVesselNameField() || this.isTodaysReport()) && <TableHeaderColumn
        expandable={false}
        width="140px"
        dataAlign="right" headerAlign="right"
        formatExtraData="linkedVesselName"
        dataField="linkedVesselName"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.vesselNameTextFormatter}
      >
        Vessel Name
      </TableHeaderColumn>
      }
      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="140px"
        dataField="counterparty"
        formatExtraData="counterparty"
        dataAlign="right" headerAlign="right"
        dataFormat={this.counterpartyFormatter}
      >
        Counterparty
      </TableHeaderColumn>
      }
      <TableHeaderColumn
        expandable={false}
        width="130px"
        dataField="dueAmount"
        formatExtraData="dueAmount"
        columnClassName={this.isTodaysReport() ? 'payments-wrapped-text-td' : ''}
        dataAlign="right" headerAlign="right"
        dataFormat={this.dueAmountFormatter}
        tdStyle={this.isSubpayment() ? { paddingLeft: 20 } : { paddingRight: 20 }}
      >
        Due Amount
      </TableHeaderColumn>
      {this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="140px"
        dataField="counterparty"
        formatExtraData="counterparty"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.counterpartyFormatter}
      >
        Counterparty
      </TableHeaderColumn>
      }
      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="114px"
        dataField="dueDate"
        formatExtraData="dueDate"
        dataAlign="right" headerAlign="right"
        dataFormat={this.dueDateFormatter}
      >
        Due Date
      </TableHeaderColumn>
      }
      <TableHeaderColumn
        expandable={false}
        width="120px"
        dataSort={!this.props.subpayment}
        sortFunc={sortPaymentAmount}
        dataField="resolvedPaymentAmount"
        formatExtraData="resolvedPaymentAmount"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatterWithCurrency}
      >
        Payment Amount
      </TableHeaderColumn>

      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="114px"
        dataField="resolvedPaymentDate"
        dataSort={!this.props.subpayment}
        sortFunc={sortPaymentDate}
        formatExtraData="resolvedPaymentDate"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatter}
      >
        Payment Date
      </TableHeaderColumn>
      }
      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="100px"
        dataField="resolvedOutstanding"
        formatExtraData="resolvedOutstanding"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatterWithCurrency}
      >
        Outstanding
      </TableHeaderColumn>
      }
      {!(this.isTodaysReport() || this.state.viewMode == BRIEF_MODE) && <TableHeaderColumn
        expandable={false}
        width="100px"
        dataSort={!this.props.subpayment}
        sortFunc={sortBankingCost}
        dataField="resolvedBankingCost"
        formatExtraData="resolvedBankingCost"
        dataAlign="right" headerAlign="right"
        columnClassName="payments-wrapped-text-td"
        dataFormat={this.simpleTextFormatterWithCurrency}
      >
        Banking Cost
      </TableHeaderColumn>
      }
      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="114px"
        dataField="bankRepaymentDate"
        formatExtraData="bankRepaymentDate"
        dataAlign="right" headerAlign="right"
        dataFormat={this.dateFormatter}
      >
        Bank Repayment Date
      </TableHeaderColumn>
      }
      {!(this.isTodaysReport() || this.state.viewMode == BRIEF_MODE) && <TableHeaderColumn
        expandable={false}
        width="160px"
        dataField="bank"
        formatExtraData="bank"
        dataAlign="right" headerAlign="right"
        dataFormat={this.bankFormatter}
      >
        Bank
      </TableHeaderColumn>
      }
      {!(this.isTodaysReport() || this.state.viewMode == BRIEF_MODE) && <TableHeaderColumn
        expandable={false}
        width="160px"
        dataField="notes"
        formatExtraData="notes"
        dataAlign="right" headerAlign="right"
        dataFormat={this.textMultiFormatter}
      >
        Notes
      </TableHeaderColumn>
      }
      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="160px"
        dataField="document"
        formatExtraData="document"
        dataAlign="right" headerAlign="right"
        className="no-right-border"
        dataFormat={this.invoiceFormatter}
      >Invoice
      </TableHeaderColumn>
      }
      {!this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="32px"
        dataField="idx"
        className="no-left-border"
        dataAlign="center" headerAlign="right"
        dataFormat={this.deleteButton}
      />
      }
      {this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="150px"
        className="no-left-border"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.productFormatter}
      >
      Product
      </TableHeaderColumn>
      }
      {this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="75px"
        className="no-left-border"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.blQuantityFormatter}
      >
      Quantity
      </TableHeaderColumn>
      }
      {this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="150px"
        className="no-left-border"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.transportNameFormatter}
      >
      Transport Name
      </TableHeaderColumn>
      }
      {this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="100px"
        className="no-left-border"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.dealPriceFormatter}
        formatExtraData="purchase"
      >
      Purchase Price
      </TableHeaderColumn>
      }
      {this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="100px"
        className="no-left-border"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.dealPriceFormatter}
        formatExtraData="sale"
      >
      Sales Price
      </TableHeaderColumn>
      }
      {this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="80px"
        dataField="idx"
        className="no-left-border"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.dealFreightFormatter}
      >
      Freight
      </TableHeaderColumn>
      }
      {this.isTodaysReport() && <TableHeaderColumn
        expandable={false}
        width="120px"
        dataField="idx"
        className="no-left-border"
        columnClassName="payments-wrapped-text-td"
        dataAlign="right" headerAlign="right"
        dataFormat={this.remarksFormatter}
      >
      Remarks
      </TableHeaderColumn>
      }
      <TableHeaderColumn
        sortFunc={sortId}
        dataField="id"
        hidden
      />
      <TableHeaderColumn
        expandable={false}
        columnClassName="lastTr"
        width="1px"
        dataFormat={() => ''}
      />
    </BootstrapTable>);
  }

  hasPaymentDate(row) {
    const elem = $('div input[name=_paymentAmount]');
    if (!elem[0]) {
      return this.getPaymentAmount(row.outstanding);
    }
    return parseFloat(elem.val());
  }

  getPaymentAmount(outstandingValue) {
    return this.state.row && !this.state.maxPayment ?
      this.state.row.paymentAmount : outstandingValue;
  }

  openEditContractPayment(pageId, paymentIdx) {
    this.setState({ showEditContractPayment: true, paymentIdx });
  }

  closeEditContractPayment() {
    this.setState({ showEditContractPayment: false, paymentIdx: null });
  }

  render() {
    if (!areAllTheDictsLoaded() || !areAllTheDealsLoaded()) {
      return <div />;
    }
    const buttonsPanel = (this.isSubpayment() || this.isTodaysReport() ? '' : <div
      style={{ padding: this.isFinancialMode() ? 0 : 3, display: 'flex', width: '100%' }}
    >
      {this.state.subPartialPayments.length > 0 || this.isFinancialMode()
        ? ''
        :
        <div>
          <Button
            bsStyle="primary"
            disabled={this.props.disabled}
            style={{ marginRight: '3px', zIndex: 20, padding: '2px 12px' }}
            onClick={this.handleAddPayment}
          >
            Add
          </Button>
          <Button
            bsStyle="primary"
            style={{ marginRight: '3px', zIndex: 20, padding: '2px 12px' }}
            onClick={this.changeViewMode}
          >
            <Glyphicon glyph={`${this.state.viewMode == BRIEF_MODE ? 'menu-hamburger' : 'th'}`} />
          </Button>
        </div>
      }
    </div>);
    // eslint-disable-next-line
    const mainDivClassName=  this.isSubpayment() ? 'sub-payment' : this.isFinancialMode() ? 'finance-table'
      : 'deal-payments-table col-xs-12';

    let outstandingValue = 0;
    if (this.state.subPartialIdx || this.state.subPartialIdx === 0) {
      const payment = this.isSubpayment() ?
        this.state.nonSubPartialPayments[this.state.subPartialIdx]
        :
        this.state.nonSubPartialPayments
          .find(p => p.paymentIdx == this.state.subPartialIdx);
      if (payment) {
        outstandingValue = payment.outstanding;
      }
    }
    const currency = this.props.currency ||
      (this.state.subPartialIdx || this.state.subPartialIdx === 0 ?
        this.props.payments.get(this.state.subPartialIdx)
          .get('dueAmountCurrency') : 'USD');
    const buttonStyle = { width: '71px', height: '30px', padding: '2px 6px' };

    let paymentExpensesType = null;
    if (this.state.row) {
      paymentExpensesType = this.state.row.expensesType;
      if (!paymentExpensesType && paymentExpensesType != 0) {
        const parent = (this.props.parentPayments || new List()).find(
          p => p.get('id') == this.state.row.parent);
        if (parent) {
          paymentExpensesType = parent.get('expensesType');
        }
      }
    }
    const paymentExpensesTypeName = (paymentExpensesType || paymentExpensesType == 0) ?
      this.props.expensestypes.find(e => e.get('id') == paymentExpensesType, this, new Map())
        .get('name', '').toLowerCase() : null;
    return (
      <div
        id={`paymentContainer ${this.props.productIdx || 0}`}
        className={mainDivClassName}
      >
        <div>
          {this.renderAdditionalElements()}
          <CreatePaymentModal
            contractDate={this.props.contractDate}
            product={this.props.product}
            dealType={this.props.dealType}
            idx={this.props.productIdx}
            resolvePaymentIdx={() => this.state.paymentIdx}
            show={this.state.showEditContractPayment}
            closeModal={this.closeEditContractPayment}
            contractor={this.props.contractor}
          />
          <Modal bsSize="small" show={this.state.showModal} onHide={this.closeModal}>
            <Modal.Header style={{ padding: '5px 20px', fontSize: '15px' }}>
              {this.state.isNewPayment ? 'New payment' : 'Payment edit'}
            </Modal.Header>
            <Modal.Body style={{ fontSize: '13px' }}>
              <form id="payment-modal" className="payment-modal">
                <Row className="payment-amount-modal" style={{ marginBottom: 10 }}>
                  <Col xs={12}>
                    <Label label="Payment amount" vertical sm={12}>
                      <Col
                        xs={2}
                        style={{ display: 'flex', alignItems: 'center',
                          height: '35px', padding: 0 }}
                      >
                        {formatCurrency(currency)}
                      </Col>

                      <Col xs={10} style={{ padding: 0 }}>
                        <FancyInput
                          className="form-control"
                          thousand
                          fraction={2}
                          positive
                          negative={false}
                          type="number"
                          onChange={this.validatePaymentAmountModal}
                          value={this.getPaymentAmount(outstandingValue)}
                          id="paymentAmount" name="paymentAmount"
                        />
                      </Col>
                    </Label>
                    {this.state.modalError ?
                      <span style={{ color: 'red' }}>{this.state.modalError}</span>
                      : ''}
                  </Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={12}>
                    <Label label="Banking cost" vertical sm={12}>
                      <Col
                        xs={2}
                        style={{ display: 'flex', alignItems: 'center',
                          height: '35px', padding: 0 }}
                      >
                        {formatCurrency(currency)}
                      </Col>
                      <Col xs={10} style={{ padding: 0 }}>
                        <FancyInput
                          className="form-control"
                          thousand
                          fraction={2}
                          positive
                          negative={false}
                          type="number"
                          value={this.state.row ? this.state.row.bankingCost : undefined}
                          id="bankingCost" name="bankingCost"
                        />
                      </Col>
                    </Label>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={12}>
                    <Label label="Payment date" vertical sm={12}>
                      <RequiredFormControl
                        component={DateTimePicker}
                        disableRequired={PRODUCT_EXPENSES_TYPE != paymentExpensesTypeName
                        || !this.hasPaymentDate(this.state.row)}
                        time={false}
                        format={dateTimePickerFormat}
                        name="paymentDate"
                        defaultValue={this.state.row && this.state.row.paymentDate ?
                          new Date(this.state.row.paymentDate) : undefined}
                      />
                    </Label>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Label label="Bank" vertical sm={12}>
                      <RefPicker
                        dict="bank" name="bank"
                        defaultValue={this.state.row ? this.state.row.bank : undefined}
                      />
                    </Label>
                  </Col>
                </Row>
              </form>
            </Modal.Body>
            <Modal.Footer style={{ padding: '10px' }}>
              <Button style={buttonStyle} onClick={this.closeModal}>Cancel</Button>
              <Button
                style={buttonStyle}
                bsStyle="primary" disabled={this.state.modalError}
                onClick={this.handleAddSubPartial}
              >Save</Button>
            </Modal.Footer>
          </Modal>

          <Modal bsSize="small" show={this.state.showModalDelete} onHide={this.closeModalDelete}>
            <Modal.Body>
            Are you sure you want to delete the payment?
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="danger" onClick={this.yesButtonDelete}>Yes</Button>
              <Button onClick={this.closeModalDelete}>No</Button>
            </Modal.Footer>
          </Modal>

          <TopManagerSelect
            show={this.state.showTopManagerModal}
            onHide={this.closeTopManagerModal}
            expiredId={this.state.expiredId}
            declinedId={this.state.declinedId}
            onSelect={this.onTopManagerSelect}
            idx={this.state.topManagerIdx}
          />
          {buttonsPanel}
          {this.state.nonSubPartialPayments && this.state.nonSubPartialPayments.length > 0
            ? this.getTable() : ''
          }
        </div>
      </div>
    );
  }
}

PaymentsContainer.propTypes = {
  productIdx: React.PropTypes.number,
  parentPaymentIdx: React.PropTypes.number,
  paymentIdx: React.PropTypes.number,
  payments: React.PropTypes.object,
  subpayment: React.PropTypes.bool,
  dealType: React.PropTypes.string,
  mode: React.PropTypes.string,
  addDealPayment: React.PropTypes.func,
  updateDealPayment: React.PropTypes.func,
  removeDealPayment: React.PropTypes.func,
  tryToSaveDealPayment: React.PropTypes.func,
  viewMode: React.PropTypes.string,
  contractNumber: React.PropTypes.string,
  currentUser: React.PropTypes.number,
  purchases: React.PropTypes.object,
  sales: React.PropTypes.object,
  transports: React.PropTypes.object,
  parentPayments: React.PropTypes.object,
  subpartial: React.PropTypes.bool,
  saving: React.PropTypes.bool,
  contractor: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
  expensestypes: React.PropTypes.object,
  topmanagers: React.PropTypes.object,
  owners: React.PropTypes.object,
  expenses: React.PropTypes.object,
  currencyRates: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]),
  currency: React.PropTypes.string,
  parentFailedValidation: React.PropTypes.bool,
  addPaymentExpense: React.PropTypes.func,
  updatePaymentExpense: React.PropTypes.func,
  removePaymentExpense: React.PropTypes.func,
  producers: React.PropTypes.object,
  vesselBroker: React.PropTypes.number,
  vesselOwner: React.PropTypes.number,
  forwarder: React.PropTypes.number,
  datchex: React.PropTypes.bool,
  setExpensesRebuilded: React.PropTypes.func,
  isDebit: React.PropTypes.bool,
  simpleDicts: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  filterIds: React.PropTypes.object,
  pageSize: React.PropTypes.number,
  currentPage: React.PropTypes.number,
  onPageChange: React.PropTypes.func,
  pageSizeOptions: React.PropTypes.array,
  paginationPanel: React.PropTypes.func,
  hideArchivedDetachedPayments: React.PropTypes.bool,
  currentDeal: React.PropTypes.object,
  docTypes: React.PropTypes.object,
  banks: React.PropTypes.object,
  insurances: React.PropTypes.object,
  inspections: React.PropTypes.object,
  brokers: React.PropTypes.object,
  forwarders: React.PropTypes.object,
  buyers: React.PropTypes.object,
  sellers: React.PropTypes.object,
  producersSelected: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]),
  showDebit: React.PropTypes.bool,
  showCredit: React.PropTypes.bool,
  isClosed: React.PropTypes.bool,
  tradecounterparties: React.PropTypes.object,
  isCommonPayments: React.PropTypes.bool,
  product: React.PropTypes.object,
  products: React.PropTypes.object,
  contractDate: React.PropTypes.string,
  currentDealJSON: React.PropTypes.string,
};

export const mapStateToProps = (state, props) => ({
  currentUser: Number(state.getIn(['session', 'id'])),
  purchases: state.getIn(['data', 'deals', 'list', 'purchase'], new List()),
  sales: state.getIn(['data', 'deals', 'list', 'sale'], new List()),
  simpleDicts: state.getIn(['references', 'simple']),
  transports: state.getIn(['data', 'deals', 'list', 'transport'], new List()),
  currencyRates: state.getIn(['data', 'currencies', 'USD', 'rates'], []),
  users: state.getIn(['data', 'users_select'], new List()),
  expensestypes: state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List()),
  banks: state.getIn(['references', 'simple', BANK_REF_PATH], new List()),
  owners: state.getIn(['references', 'simple', OWNER_REF_PATH], new List()),
  docTypes: state.getIn(['references', 'simple', DOCTYPE_REF_PATH], new List()),
  insurances: state.getIn(['references', 'simple', INSURANCECOMPANY_REF_PATH], new List()),
  inspections: state.getIn(['references', 'simple', INSPECTIONCOMPANY_REF_PATH], new List()),
  brokers: state.getIn(['references', 'simple', VESSEL_BROKER_REF_PATH], new List()),
  forwarders: state.getIn(['references', 'simple', FORWARDER_REF_PATH], new List()),
  buyers: state.getIn(['references', 'simple', BUYER_REF_PATH], new List()),
  sellers: state.getIn(['references', 'simple', SELLER_REF_PATH], new List()),
  producers: state.getIn(['references', 'simple', PRODUCER_TYPE_REF_PATH], new List()),
  topmanagers: state.getIn(['references', 'simple', TOPMANAGER_REF_PATH], new List()),
  paymentMethods: state.getIn(['references', 'simple', PAYMENTMETHOD_REF_PATH], new List()),
  commoncounterparties: state.getIn(['references', 'simple',
    COMMONCOUNTERPARTIES_REF_PATH], new List()),
  tradecounterparties: state.getIn(['references', 'simple',
    TRADE_COUNTERPARTIES_REF_PATH], new List()),
  expenses: props.dealType == 'transport' ?
    state.getIn(['data', 'deals', 'deal', 'expenses'], new List())
    :
    state.getIn(['data', 'deals', 'deal', 'products', props.productIdx, 'expenses'], new List()),
  saving: state.getIn(['allaround', 'saving'], false),
  payments:
    props.payments ||
    (props.productIdx >= 0
      ? state.getIn(['data', 'deals', 'deal', 'products', props.productIdx, 'payments'],
        new List())
      : state.getIn(['data', 'deals', 'deal', 'payments'], new List())),
  storeStatus: state.getIn(['storeStatus']),
  products: state.getIn(['data', 'deals', 'deal', 'products']),
  filterIds: state.getIn(['search', 'payments', 'data'], new List()),
});

const getCurrentDeal = state => state.getIn(['data', 'deals', 'deal']);
const deletePaymentsAndExpenses = products => {
  if (!products) {
    return undefined;
  }
  return products.map(product => product.delete('payments').delete('expenses'));
};
const dealWithoutPayments = createSelector([getCurrentDeal], (currentDeal) => {
  if (!currentDeal) {
    return undefined;
  }

  return currentDeal.delete('payments').delete('expenses')
    .set('products', deletePaymentsAndExpenses(currentDeal.get('products')));
});

const currentDealJSON = state => JSON.stringify(dealWithoutPayments(state));

const mapStateToPropsFin = (state, props) => ({ ...mapStateToProps(state, props), ...{
  hideArchivedDetachedPayments:
    state.getIn(['search', 'payments', 'filters', 'isarchived'], false),
  currentDeal: dealWithoutPayments(state),
  currentDealJSON: currentDealJSON(state),
  storeStatus: undefined,
} });

InternalSubPaymentsContainer = connect(mapStateToPropsFin,
  (dispatch, props) => ({
    addDealPayment(paymentIdx, payment, insertAt0) {
      const paymentIdxs = [];
      if (props.parentPaymentIdx >= 0) {
        paymentIdxs.push(props.parentPaymentIdx);
      }
      if (props.paymentIdx >= 0) {
        paymentIdxs.push(props.paymentIdx);
      }
      if (paymentIdx >= 0) {
        paymentIdxs.push(paymentIdx);
      }
      if (props.mode == 'financial') {
        tryToSaveDealPayment(dispatch, payment, props.productIdx, paymentIdxs, true);
      } else {
        addDealPayment(dispatch, props.productIdx, paymentIdxs, payment, insertAt0);
        handleFormChanged(dispatch);
      }
    },
    updateDealPayment(paymentIdx, payment) {
      const paymentIdxs = [];
      if (props.parentPaymentIdx >= 0) {
        paymentIdxs.push(props.parentPaymentIdx);
      }
      if (props.paymentIdx >= 0) {
        paymentIdxs.push(props.paymentIdx);
      }
      if (paymentIdx >= 0) {
        paymentIdxs.push(paymentIdx);
      }
      if (props.mode == 'financial') {
        tryToSaveDealPayment(dispatch, payment, props.productIdx, paymentIdxs, false);
      } else {
        updateDealPayment(dispatch, props.productIdx, paymentIdxs, payment);
        handleFormChanged(dispatch);
      }
    },
    removeDealPayment(paymentIdx, id) {
      const paymentIdxs = [];
      if (props.parentPaymentIdx >= 0) {
        paymentIdxs.push(props.parentPaymentIdx);
      }
      if (props.paymentIdx >= 0) {
        paymentIdxs.push(props.paymentIdx);
      }
      removeDealPayment(dispatch, props.mode == 'financial', id,
        props.productIdx, paymentIdxs, paymentIdx);
      handleFormChanged(dispatch);
    },
    tryToSaveDealPayment(payment) {
      tryToSaveDealPayment(dispatch, payment);
    },
    addPaymentExpense(expense) {
      if (props.dealType == 'transport') {
        addTransportExpense(dispatch, expense);
      } else {
        addDealExpense(dispatch, props.productIdx, expense);
      }
    },
    updatePaymentExpense(expenseIdx, expense) {
      if (props.dealType == 'transport') {
        updateTransportExpense(dispatch, expenseIdx, expense);
      } else {
        updateDealExpense(dispatch, props.productIdx, expenseIdx, expense);
      }
    },
    removePaymentExpense(expenseIdx) {
      if (props.dealType == 'transport') {
        removeTransportExpense(dispatch, expenseIdx, true);
      } else {
        removeDealExpense(dispatch, props.productIdx, expenseIdx, true);
      }
    },
    setExpensesRebuilded() {
      setExpensesRebuilded(dispatch, props.productIdx);
    },
  })
)(PaymentsContainer);

const SubPaymentsContainer = InternalSubPaymentsContainer;

export default SubPaymentsContainer;
